module.exports = {
    en: {
        trad: "en",
        saved: "saved",
        admin: {
            componentForm: {
                goBackButton: "Back",
                createHead: "Create a component",
                editHead: "Edit component",
                subhead: "Brand: {{brand}}",
                componentType: "Component type",
                compotentTypeNames: {
                    caddy: "Caddy",
                    module: "Module",
                    product: "Product",
                    accessory: "Accessory",
                    divider: "Divider",
                    shelf: "Shelf",
                    ticketStrip: "Ticket strip",
                    fascia: "Fascia",
                    frame: "Frame",
                    ladder: "Ladder",
                    display: "Display",
                    blankingGraphic: "Blanking Graphic"
                },
                name: "Name",
                shortName: "Short Name",
                systemType: "System type",
                systemTypes: {
                    caddy: "Caddy",
                    shelf: "Shelf",
                    tile: "Tile",
                    newTile: "New tile"
                },
                design: "Design",
                availableOn: {
                    label: "Available on",
                    carcass: "Carcass",
                    template: "Template",
                    planogram: "Planogram"
                },
                defaultCampaign: {
                    label: "Default campaign",
                    onGoing: "On going",
                    defaultLaunchAndDiscontinuation: "Default launch and discontinuation campaign",
                    zonesAndMarkets: "Zones / Markets",
                    description: "Description",
                    status: "Status",
                    noStatus: "none",
                    categories: "Categories",
                    addCategory: "+add category",
                    estoreAvailability: {
                        label: "e-store",
                        unavailable: "Not available",
                        diamOnly: "Diam use only",
                        everybody: "Available to everybody"
                    }
                },
                estore: {
                    label: "E-Store",
                    applyPrices: "Apply to zones",
                    defaultPrice: "Default Price",
                    estoreAvailability: {
                        label: "e-store",
                        unavailable: "Not available",
                        diamOnly: "Diam use only",
                        everybody: "Available to everybody"
                    }
                },
                references: {
                    label: "References"
                },
                missingProperties: "check the mandatory fields (marked with a red star)",
                successEditedMessage: "Component edited successfully"
            }
        },
        template: {
            form: {
                loadingError: "Form is still loading",
                missingError: ":name is required but missing",
                name: "Name",
                link: "Link",
                ref: "Reference",
                zone: {
                    label: "Zone",
                    empty: "Please select a zone"
                },
                standDesign: {
                    label: "Stand Design",
                    empty: "Please select a stand design"
                },
                displayerType: {
                    label: "Displayer type",
                    empty: "Please select a displayer type"
                },
                category: "Category"
            }
        },
        systemTypes: {
            1: "tile",
            2: "shelf",
            3: "caddy",
            4: "new caddy"
        },
        error: {
            403: {
                error: "ERROR!",
                errorText: "ACCESS DENIED"
            },
            404: {
                error: "ERROR!",
                errorText: "PAGE NOT FOUND"
            }
        },
        actions: {
            confirm: "Confirm",
            search: "Search",
            cancel: "Cancel",
            addUser: "Add a new user",
            remove: "Remove"
        },
        changeAccess: {
            title: "update access",
            desactivate:
                "Are you sure you want to deactivate <b>{fullName}</b> from REM3RCH ? <br />" +
                "This user won't be able to access the site anymore, regardless of the brand.",
            activate:
                "Are you sure you want to re-activate <b>{fullName}</b> on REM3RCH ?  <br />" +
                "This user will have access to all the brands he previously had access to.",
            disconnectUser: {
                title: "Your profile has been modified.",
                text: "You will need to re-identify yourself in the application."
            }
        },
        createUser: {
            title: "Add new user",
            msgSearch: "Enter his/her email address to check if this user already has an account in Rem3rch :",
            hasAccessBrand: "This user is already registered in Rem3rch with an access to {brand}",
            updateBrand: "This user is already registered in Rem3rch, but with access to another brands :",
            confimUpdateBrand: "Do you confirm a new access to the brand {brand} ?",
            InputEmpty: "This user is not currently in our database. Please fill in the following fields to complete the user creation.",
            labelMan: "Man",
            labelWoman: "Woman",
            labelGenre: "Genre",
            fieldsError: "Required fields",
            labelFirstName: "First name",
            labelLastName: "Last name",
            labelEmail: "E-mail",
            labelBrand: "Brand",
            searchIt: "Search it",
            backToUsersList: "Back to users list",
            yesIConfirm: "Yes I confirm",
            manageUserRights: "Manage user's rights"
        },
        deleteBrand: {
            message: "Are you sure you want to delete the brand {brand} from the user",
            messageAction: "This action cannot be undone.",
            msgDelete: "You must logout for deletion to take effect",
            confirmTitle: "ERROR",
            warningText: "Deletion is not allowed because it is being used as reference"
        },
        userList: {
            title: "Users",
            viewActiveOnly: "View only active users",
            activateAllBrands: "Activate all brands",
            brand: "Brand",
            email: "email",
            remerchAccess: "REMERCH access",
            lastConnection: "last connection",
            emptyList: "Empty list",
            search: "Search",
            edit: "edit",
            delete: "delete",
            history: "history"
        },
        gui: {
            form: {
                error: {
                    mandatory: "This field is mandatory",
                    integer: "Value expected integer",
                    float: "Value expected float",
                    email: "Email is not validate",
                    mask: "The field is not validate "
                }
            }
        },
        cguModal: {
            title: "Terms and Conditions",
            acceptButton: "I read and accept the terms and conditions",
            refuseButton: "Refuse",
            acronyme: "T&C"
        },
        checkBoxModal: {
            selectAll: "Select all",
            selectNone: "Select None",
            copyButton: "Copy to all these zones"
        },
        StatStatus: {
            titleArchived: "Archived/UnArchive",
            titleChangeStatus: "Change Status",
            contentArchived: "Êtes vous sur de vouloir",
            contentStatus: "Êtes vous sur de changer le status",
            cancel: "Annuler",
            valider: "Valider",
            labelArchived: "Archive",
            labelDesarchived: "UnArchive"
        },
        userAccess: {
            title: "MANAGE USERS BRAND ACCESS",
            search: "Search",
            clear: "Clear",
            brandAccessed: "Acces to the following brands",
            addAccess: "Add to the current brand",
            close: "CLOSE",
            super: "THIS USER IS A SUPER ADMIN",
            alreadyAccess: "THIS USER HAS ALREADY ACCESS TO THE CURRENT BRAND",
            infoSavedBrand: "Don't forget to give access to the brand functionnalities",
            linkButton: "Manage User Brand",
            alertMessage: "Are you sure you want to delete the access to this brand ?"
        },
        countdown: {
            nextcntd: "Upcoming countdowns",
            accessdenied: "Access denied.",
            creatnewcntd: "Create new countdown",
            listcntd: "Show list",
            emptycntd: "Countdown list is empty",
            colname: "Name",
            colstartdate: "Start date",
            colenddate: "End date",
            colstanddesign: "Stand design",
            colbrand: "Brand",
            colcreateupdate: "Create/Update",
            adddesc: "Enter description",
            btncreate: "Create",
            btncancel: "Cancel",
            btndelete: "Delete",
            confirmdelete: "Please confirm, deleting countdown "
        },
        preferences: {
            title: "User preferences",
            label: {
                name: "Name",
                userName: "Firstname",
                password: "Password",
                language: "language (default)",
                brand: "Brand (default)",
                zoned: "zone (default)",
                stands: "Stand design (default)",
                campaign: "Campaign (default)"
            },
            option: {
                language: "Last value",
                brand: "Last value",
                zoned: "Last value",
                stands: "Last value",
                campaign: "Last value"
            },
            message: {
                valider: "Save Preferences"
            },
            btn: {
                label: "Save Preferences"
            },
            terms: "You accepted terms of services on 05/04/2018.  Read terms of services",
            subscription: "Subscription to Rem3rch : Read subscription details",
            successMessage: "Preferences saved"
        },
        shelfEditor: {
            componentTypeLabel: "Component type"
        },
        fasciaEditor: {
            colorLabel: "Color",
            width: "Width",
            height: "Height"
        },
        blankingGraphicEditor: {
            width: "Width",
            height: "Height"
        },
        frameEditor: {
            colorLabel: "Color",
            width: "Width",
            height: "Height",
            thickness: "Thickness"
        },
        dividerEditor: {
            width: "Width",
            height: "Height"
        },
        plano: {
            editor: {
                confirmDeleteFavorite: "Do you really want to delete the favorite?",
                generateLadders: {
                    label: "Generate ladders",
                    subhead: "Inner content: width = {{width}}mm / height = {{height}}mm",
                    leftPadding: "left (x)",
                    rightPadding: "right (x)",
                    topPadding: "top (y)",
                    bottomPadding: "bottom (y)",
                    generatedHeight: "Total height: {{height}}",
                    generatedWidth: "Total width: {{width}}"
                },
                generateFixings: {
                    subhead: "Inner content: width = {{width}}mm / height = {{height}}mm",
                    label: "Generate fixings",
                    pickCaddyLabel: "choose your caddy reference",
                    horizontalCount: "repetition width (x): ",
                    verticalCount: "repetition height (y): ",
                    spacingLabel: "spacing between two caddies",
                    horizontalSpacing: "width (x)",
                    verticalSpacing: "height (y)",
                    paddingLabel: "outside padding",
                    leftPadding: "left (x)",
                    rightPadding: "right (x)",
                    topPadding: "top (y)",
                    bottomPadding: "bottom (y)",
                    save: "save",
                    cancel: "cancel",
                    caddyOption: "{{name}} – width: {{width}} / height: {{height}} "
                },
                moveFixings: {
                    title: "Move Fixings",
                    position: "Position"
                },
                resizePaper: {
                    label: "Resize paper",
                    width: "Width:",
                    height: "Height:",
                    direction: {
                        label: "Direction",
                        left: "Left",
                        center: "Center",
                        right: "Right"
                    },
                    ok: "Ok",
                    cancel: "Cancel"
                },
                header: {
                    file: {
                        label: "File",
                        save: "Save",
                        saveAs: "Save As",
                        saveAsTemplate: "Save As Template",
                        renamePlanogram: {
                            labelMenu: "Rename",
                            labelRenamePlano: "Rename",
                            close: "Cancel",
                            valider: "validate"
                        },
                        saveAndExit: "Save and Exit",
                        exit: "Exit"
                    },
                    export: {
                        label: "Export",
                        print: "Print",
                        exportPdf: "Export PDF",
                        exportLdPdf: "Export LD PDF",
                        exportExcel: "Export Excel"
                    },
                    window: {
                        label: "Window",
                        toolbar: "Toolbar",
                        library: "Library",
                        dummies: "Newbie bar"
                    },
                    help: {
                        label: "Help",
                        shortcutList: {
                            label: "Shortcuts",

                            "zoom+": "Zoom +",
                            "zoom-": "Zoom -",
                            copy: "Copy",
                            paste: "Paste",
                            save: "Save",
                            undo: "Undo",
                            redo: "Redo",
                            delete: "Delete",
                            edit: "Edit",
                            addToFavorites: "Add to favorites",
                            group: "Group",
                            ungroup: "Ungroup",
                            print: "Print",
                            magnet: "Toggle magnet",
                            toggleLayers: "Toggle layers",
                            toggleLibrary: "Toggle component library"
                        },
                        fileInfo: "File Info",
                        help: "Help"
                    }
                },
                infoStatistic: {
                    modules: "Modules",
                    shades: "Shades",
                    shelves: "Shelves",
                    caddies: "Caddies"
                },
                exportPdfModal: {
                    title: "PDF Setup up",
                    printQuality: "Quality",
                    lowQuality: "Low Definition",
                    highQuality: "High Definition",
                    overviewPage: "Add page overview front page",
                    shadesPage: "Add shades page",
                    infoPage: "Add plano info on last page",
                    planoInfoTitle: "Planogram Informations",
                    shadesPageTitle: "Shades",
                    overviewPagePager: "Overview",
                    noShades: "No shades"
                },
                corruptedModulesModal: {
                    title: "Some items are missing or corrupted",
                    subTitle: "Please contact the REM3RCH team for more information.",
                    missingModuleMessage: "component unavailable for this planogram"
                }
            },
            template: {
                errorNoCarcass: "At least one carcass is required"
            },
            lock: "Locked",
            noresult: "Sorry, no results were found for your search.",
            errorSetLoginAttempts: "An error occured : the number of login attempts could not be resetted.",
            buttonLoginAttempts: "Login Attempts  Reset",
            gotocatalogue: "Go to catalog",
            search_planogram: "Search a planogram",
            create: "+ Create a planogram",
            select_campaign_label: "Campaign",
            select_campaign_ele: "ALL CAMPAIGNS",
            select_zone_label: "Zone",
            select_zone_ele: "---",
            select_height_label: "Height",
            select_height_ele: "---",
            select_width_label: "Width",
            select_width_ele: "---",
            select_brand_label: "Client",
            select_brand_ele: "---",
            select_stand_type_label: "Displayer type",
            select_stand_design_label: "Stand Design",
            select_sortBy_label: "Sort by",
            select_sortBy_ele: "Creation date",
            duplicate_plano: "Duplicate this Planogram",
            enter_new_name: "Enter a new name to your planogram",
            select_campaign: "Select campaign type",
            select_zone: "Select a zone",
            btn_validate: "Validate",
            name_placeholder: "Your planogram name",
            your_plano: "Your Planogram",
            duplicate_message: "has been duplicated under the name",
            open_plano: "Open planogram",
            note_duplicate_plano: "Please note: Make sure to change your campaign/zone accordingly to see your new planogram",
            confirmExit: {
                title: "Do you want to save the changes made to the planogram {name} ?",
                message: "(Your changes will be lost if you don’t save them)",
                dontSaveButton: "Don't Save",
                saveButton: "Save",
                cancelButton: "Cancel"
            },
            saveAsModal: {
                saveAsLabel: "Save as"
            },
            savePlanoAsTemplate: {
                title: "Save this planogram as a Template",
                label: "Name",
                infos: {
                    title: "Infos",
                    zone: "zone",
                    standDesign: "Stand design",
                    height: "Height",
                    width: "Width"
                }
            },
            renameFavoriteModal: {
                title: "Rename Favorite"
            },
            infoModal: {
                informationGeneralTitle: "Main informations",
                informationPlanogramTitle: "Planogram informations",
                repartitionTitle: "Repartition",
                name: "name",
                zone: "zone",
                designAndCampaign: "design / campaign",
                design: "design",
                size: "size",
                type: "type",
                createdOn: "created on",
                modifiedOn: "last modified on",
                modulesQuantity: "Modules Quantity",
                shadesQuantity: "Shades Quantity",
                shelvesQuantity: "Shelves Quantity",
                caddiesQuantity: "Caddies Quantity",
                modulesSku: "Modules Sku",
                shadesSku: "Shades Sku",
                caddySku: "Caddy Sku",
                shelvesSku: "Shelves Sku",
                noHighlightColor: "No Highlights for this brand"
            },
            caddy: {
                editor: {
                    frames: {
                        title: "frames"
                    },
                    tickets: {
                        title: "tickets"
                    },
                    fascias: {
                        title: "fascias",
                        create: "create a new fascia"
                    }
                }
            }
        },
        common: {
            open: "Open",
            cancel: "Cancel",
            close: "Close",
            finish: "Close",
            footerDate: "© REM3RCH-2020",
            deconnexion: "Logout",
            profil: "My profile",
            preferences: "Preferences",
            edit: "Edit",
            pdf: "Download PDF",
            download: "download",
            upload: "upload",
            error: "Ooops, something went wrong. Sorry for the inconvenience.",
            exportPDF: "Export PDF",
            search: "Search",
            delete: "delete",
            disable: "disable",
            remove: "remove",
            history: "history",
            ok: "OK",
            save: "Save",
            reset: "Reset",
            saveAs: "Save as",
            versioning: "Versioning",
            create: "Create",
            createBasket: "Create a new basket",
            ref: "Reference",
            required: "Required",
            campaign: "Campaign",
            by: "by",
            searchAll: "All the components",
            mobileNotDispo: "This functionality is not currently available on smartphones.",
            planogram: "Planogram",
            catalog: "Catalog",
            brand: "Brand",
            selectAll: "Select all",
            selectNone: "Select none",
            resetSelection: "Reset selection",
            dateTimeFormat: "YYYY-MM-DD [at] HH:mm",
            yes: "yes",
            no: "no"
        },
        formErrorMessages: {
            fieldMissingMessage: "Some data are incorrect. Please review the following fields",
            emptyField: "This field is required",
            mailInvalid: "Please enter a valid email address",
            fieldTooLong: "Field too long(Max length {maxLength})",
            color: "Please fill this field with a valid color format (ex : blue, rgb(0,0,255) or #0000FF)",
            max: "max long {max} caracter",
            min: "at least {min} caracteres",
            isColor: "is not color",
            required: "is required",
            isBool: "Incorrect value",
            isArray: "Incorrect value"
        },
        headerAdmin: {
            meuble: "DISPLAY CONFIGURATION",
            campaign: "CREATE A CAMPAIGN",
            list: "CAMPAIGN LIST",
            template: "PLANOGRAM TEMPLATE",
            cpnt_management: "CREATE COMPONENT",
            displayers: "DISPLAYERS",
            client: "client",
            admin: "admin",
            super_admin: "super admin",
            uploadPage: "Import components",
            zone: {
                add: "ADD NEW ZONE",
                create: "CREATE NEW ZONE",
                displayDeletedZone: "Display deleted zones",
                client_ref: "client ref",
                name: "name",
                type: "type",
                group: "group",
                brands: "brands",
                users: "users",
                edit_type: "edit type",
                parameters: "parameters",
                deleted: "deleted"
            },
            design: "DESIGNS",
            brand: "Brand",
            zoneList: "ZONES",
            zone_group: {
                manage: "manage zone group"
            },
            componentList: "COMPONENT TYPE",
            user: "USERS"
        },
        menuCatalogStar: {
            linkViewFeattured: "View featured",
            linkViewAll: "View all"
        },
        dashboardModule: {
            catalogTitle: "Catalog",
            planoTitle: "Planograms",
            catSubTitle: "Last updates",
            featureTitle: "Featured",
            myOrdersTitle: "My orders",
            planoSubTitle: "last modifications",
            newItem: "Create a new item",
            seeAllCat: "Open Catalog",
            seeAllPlanos: "Open planograms",
            seeAllOrders: "See all my orders",
            open: "Open",
            option: "Options",
            changeBrand: "Change brand",
            changeZone: "Change zone",
            changeCampaign: "Change campaign",
            allCampaign: "All campaigns",
            allCampaignShort: "All camp.",
            information: "Informations",
            info: "Infos",
            thOrderID: "Order ID",
            thBuyer: "Buyer",
            thLastActivity: "Last activity",
            thStatus: "Status"
        },
        menuHeader: {
            homeLink: "Home",
            catalogueLink: "Catalog",
            planoLink: "Plano builder",
            planosLink: "Planos",
            forecastLink: "Launch Forecast",
            catalogForecastLink: "Catalog Forecast",
            tools: {
                name: "tools",
                manageUsers: "manage users",
                manageZones: "manage zones",
                manageCampaigns: "manage campaigns",
                exportExcel: "archive export"
            },
            menu: "Menu",
            selectBrand: "select brand",
            selectZone: "Select zone",
            selectCampaign: "Select campaign",
            godMode: "God Mode",
            help: "Help"
        },
        help: {
            title: "Help",
            catalog: "catalog",
            launch_forecast: "launch forecast",
            catalog_forecast: "catalog forecast",
            tools: "tools",
            uploadPdf: "Upload<br>PDF",
            uploadPdfError: "Upload PDF error",
            noFile: "No file",
            newPdf: "Add new PDF",
            newVideo: "Add new video",
            filter: "Filter",
            category: "Category",
            howTo: "How to",
            videoTraining: "Video training",
            noItem: "No element in this category"
        },
        shades: {
            title: "SHADES",
            allActive: "Current Zone active shades",
            zoneShades: "Current Zone all shades",
            allShades: "All shades all zones",
            add: "ADD SHADE",
            edit: "Edit",
            noShades: "sorry, no shades available",
            import: "IMPORT SHADES",
            label: "shades",
            certified: "Certified shade",
            color: "Color",
            campaignL: "Campaign launch",
            msgResultSearch: "Your search returned <span>{result}</span> results",
            afterDelete: "This shade is not used on any planogram.",
            confirmDelete: "Confirm deletion",
            deleteWarning: "This teinte is used in the following planogram(s) :",
            btndelete: "delete",
            form: {
                name: "Please entre the name",
                ref1: "Please entre the Client Ref1"
            }
        },
        product: {
            back: "Back to search result",
            notPublished: "[Not Published]",
            articleInfos: "product information",
            zoneCampaignInfos: "Zone and Campaign Information",
            description: "description",
            price: "* Recommended retail price",
            relatedProduct: "related products",
            productsModule: "product used on the following modules",
            manage: "Manage association",
            launch: "Launch",
            discontinued: "Discontinued",
            noComponent: "This component is not available for the selected campaign/zone",
            publish: "Published",
            ticket: "Manage ticket strips",
            errorCompagn: "Please select a compaign",
            labelLancement: "Launch date",
            labelDiscontinuer: "Discontinuation date",
            labelSelectZone: "Select zone",
            labelCertif: "Certified shade",
            deleteModal: {
                confirmTitle: "Delete this component ?",
                warningText: "Are you sure? You won't be able to revert this!",
                confirmDelete: "Yes, delete it!"
            }
        },
        contentPage: {
            backToSearch: "Back",
            btnEdit: "Update"
        },
        modulePage: {
            infosArticle: "Item details",
            description: "Description",
            productsModule: "Products on module",
            moduleProduct: "Module on product",
            ticketStrips: "Ticket strips",
            allTickets: "View all ticket strips"
        },
        catalogue: {
            clear: "Reset filters",
            weFound: "Your search",
            results: "Results",
            for: "for",
            return: "returned",
            tri: "Sort",
            filter: "Filters",
            allCampaign: "All campaigns",
            exportpdf: "ADD INTO EXPORT PDF",
            basket: "ADD TO BASKET",
            allZonesAbr: "all",
            allZonesDesc: "",
            allZonesName: "All zones",
            comment: "Comment",
            status: "Status",
            none: "None",
            updateStatusButton: "Update status",
            updateStatusSuccess: "Status Updated",
            systemType: "System type",
            filters: {
                component: "Components",
                standDesign: "Stand Design",
                status: "Status",
                systemType: "System",
                starred: "Starred",
                published: "Published",
                categories: "Categories",
                sections: "Sections"
            }
        },
        login: {
            forgot: "Forgot your password ?"
        },
        change: {
            selectBrand: "Select Brand"
        },
        meublePlano: {
            save: "Save",
            numberOfBlocs: "Number of divider",
            blocWidth: "Blocs width",
            setBloc: "Set blocs",
            stripSize: "Strip size",
            segmentation: "Segmentation",
            name: "Name",
            title: "Configuration planogram display",
            externalSize: "External sizes",
            internalSize: "Interal sizes",
            width: "Width",
            height: "Height",
            header: "Header",
            footer: "Footer",
            planoModule: "Inner shopping size",
            pitchH: "Horizontal pitch",
            pitchR: "Number of repetitions",
            pitchV: "Vertical pitch",
            remainingSpaceH: "Horizontal remaining space",
            remainingSpaceV: "Vertical remaining space",
            error: "The combinaison pitch x repetitions excess the size of the display",
            errorSetStandDesign: "You need to specify a stand design"
        },
        templatePlano: {
            type: "Type",
            size: "Size",
            template: "Template",
            summary: "Summary",
            createTitle: "Create a planogram",
            planoName: "Enter a title to your planogram",
            campaign: "Select a campaign",
            sizeTitle: "Select a planogram size",
            templateTitle: "Select a planogram template",
            planoName: "Planogram name",
            campaignS: "Campaign",
            zone: "Zone",
            standDesign: "Stand Design",
            zoneTitle: "Select a zone",
            brand: "Brand",
            brandTitle: "Select a brand",
            planoSize: "Planogram size",
            planoTemp: "Planogram template",
            send: "Save",
            nextStep: "Next step",
            previousStep: "Previous Step",
            title: "Planogramme name",
            width: "Width",
            widthTitle: "Select a width",
            height: "Height",
            heightTitle: "Select a height",
            NoSizesAvailable: "No match has been found for your selection. Please go back and modify your selection."
        },
        planoSelect: {
            edit: "Edit",
            duplicate: "Duplicate",
            move: "Move",
            addToFavorite: "Add to favorite",
            addToScratchpad: "Add to scratchpad",
            group: "Group",
            deleteModule: "Delete",
            ungroup: "Ungroup",
            ungroupall: "Ungroup all",
            addComment: "Add a comment"
        },
        favorite: {
            title: "Save as favorite",
            name: "Please name this favorite",
            save: "save",
            noFavorite: "No favorite"
        },
        commentPanel: {
            title: "Notes / Comments",
            personalNoteTitle: "Personal Note",
            removePersonalNote: "remove",
            send: "Send comment",
            addComment: "Add Comment",
            addPersonalNote: "Save as a Personal Note",
            allComments: "View all comments",
            reply: "Replies",
            asOpened: "Tag as opened",
            asClosed: "Tag as closed",
            includePdf: "Include comments in PDf",
            excludePdf: "Remove comments from PDf",
            confirmDelete: "Are you sure to delete this Personal Note ?",
            deleteAction: "Delete",
            updateCommentMessage: "Comment updated succesfully",
            updateCommentErrorMessage: "An error occurred while updating this comment",
            newCommentMessage: "New comment added succesfully",
            newCommentErrorMessage: "An error occurred while saving your comment",
            deletePersonalNoteSuccessMessage: "Personal note removed",
            deleteCommentErrorMessage: "An error occurred while removing your personal note",
            replySubCommentPh: "Your reply",
            newCommentPh: "Your note / comment",
            replyButton: "Reply"
        },
        comments: {
            send: "Send Comment"
        },
        headerPlano: {
            cancel: "Cancel",
            saveExit: "Save and exit",
            save: "Save",
            back: "Back"
        },
        planoList: {
            planogram: "Planograms",
            lock: "Locked by",
            created: "Created",
            modified: "Modified",
            by: "By",
            visibility: "Visibility",
            comments: "Comments",
            option: "Options",
            duplicate: "Duplicate",
            delete: "Delete",
            submitted: "Submitted",
            in_progress: "In Progress",
            approved: "Approved",
            history: "Version history",
            editName: "Edit Name",
            order: {
                level: "Level",
                cd_asc: "Creation date Ascending",
                cd_desc: "Creation date Descending",
                md_asc: "Modification date Ascending",
                md_desc: "Modification date Descending",
                camp_asc: "Campaign Ascending",
                camp_desc: "Campaign Descending",
                h_asc: "Height Ascending",
                h_desc: "Height Descending",
                w_asc: "Width Ascending",
                w_desc: "Width Descending"
            }
        },
        planobuilder: {
            export: "export",
            support: "support",
            comment: "comments",
            favorite: "favorites",
            scratch: "scratchpad",
            library: "library",
            shades: "shades",
            ticketStrip: "Ticket strip",
            saveShades: "save",
            cancelShades: "Cancel",
            view: "Render",
            hide: "Hide",
            by: "Created by",
            modifiedBy: "Modified by",
            on: "on",
            blackwhite: "Black & White",
            iconscolors: "Icons colors",
            shadesRef: "Shades",
            realistic: "Realistic",
            frameHide: "Accessories",
            highlights: "Highlights",
            messageAlert: "In order to display the planogram in a different language, the planogram will be saved.",
            messageAlert1: "This ticket strip is not related to this module.",
            messageAlert2: "You can't put this module here because this location is not available",
            messageAlert3: "The module can not be out of the plano",
            warning: "Warning",
            layer: "Layers",
            modules: "Modules",
            reference: "Reference",
            selection: "Selection",
            pan: "Pan",
            ungroupall: "Ungroup all",
            posInit: "Position initial",
            zoomModule: "Zoom Module",
            zoomIn: "Zoom in",
            zoomOut: "Zoom out",
            exportPreview: "Export PDF with page setup",
            exportPDF: "Direct Export PDF",
            exportXLS: "Export XLS",
            highDefinition: "High Definition",
            lowDefinition: "Low Definition",
            popinModuleErrorTitle: "Warning, following modules are not available for this zone and this campain:",
            highlightsShade: {
                menu: {
                    blue: "Blue",
                    red: "Red",
                    yellow: "Yellow",
                    green: "Green",
                    violet: "Violet",
                    none: "None"
                }
            }
        },
        crudComponent: {
            name: "name",
            uses: "Types of use",
            nameEnRequired: "Cpnt name (en) is required",
            nameFrRequired: "Cpnt name (fr) is required",
            nickname: "Plano module name",
            nicknameEnRequired: "Cpnt Plano module name (en) is required",
            nicknameFrRequired: "Cpnt Plano module name (fr) is required",
            description: "description",
            descriptionEnRequired: "Cpnt description (en) is required",
            descriptionFrRequired: "Cpnt description (fr) is required",
            type: "Plano type",
            chooseBrand: "Active brand",
            chooseCategory: "Choose Category / Sub Category",
            chooseStatus: "Choose a status",
            selectCategory: "Choose a Category",
            selectStatus: "Choose a status",
            categoryRequired: "Categories must be selected",
            addCategory: "Add category",
            removeCategory: "Remove category",
            choosedefaultCampaign: "Choose a default campaign",
            launchDate: "Launch campaign",
            standDesign: "Stand Design",
            discontinued: "Discontinued campaign",
            selectCampaign: "Select campaign",
            addProperties: "Add properties",
            title: "Create a component",
            selectSubCat: "Choose a sub category",
            eStoreTypeTitle: "Available for e-Store",
            chooseSystemType: "Choose a system type",
            applyPrices: "Apply to zones"
        },
        eStoreType: {
            nobody: "Not available",
            everybody: "Everybody",
            diam: "Only Diam Users"
        },
        displayer: {
            create: "create a new display configuration",
            filters: "filters",
            delete: "Delete",
            edit: "edit"
        },
        imgEditor: {
            delete: "Delete",
            addPicture: "Add/Modify picture",
            close: "Close",
            save: "Save",
            infoDrag: "You can re-arrange the order of the images by  drag and drop",
            labelImg: "Upload a new image",
            labelSelect: "Select the image type",
            invalidFormat: "Unsupported image format: please upload a png, jpg or svg file.",
            noImage: "Please upload an image before saving."
        },
        modalComment: {
            noComment: "No comment recorded on this planogram"
        },
        related: {
            showOnly: "Show only Modules on same Catagory/ Sub-category",
            search: "Search"
        },
        scratchPad: {
            noScratch: "No item added to scratchpad"
        },
        exportPdfPlano: {
            iconLayout: "Icon layout",
            page: "Page",
            export: "Export PDF",
            close: "Close",
            exportXls: "Export XLS"
        },
        duplicatePlano: {
            saveName: "This name already exists",
            enterName: "Please enter a plano name",
            selectCampaign: "Please select a campaign",
            selectZone: "Please select a zone"
        },
        component: {
            configurator: "Module editor",
            imgEditor: "Image editor",
            notPublished: "Not Published",
            categories: "Hierarchy", //Categories
            subCat: "Sub-Categories",
            nickname: "Nickname",
            typeComponentForPlano: "Plano type",
            nameEn: "Name EN",
            nameFr: "Name FR",
            moduleConfifured: "Module configured on {date} by {user}",
            moduleLastModified: "Configuration last modified on {date} by {user}",
            savePrices: "Save prices",
            cancel: "Cancel"
        },
        campaign: {
            create: "Create a campaign",
            brand: "Select a brand",
            standDesign: "Stand design",
            selectStandDesign: "Select a stand design",
            startCampaign: "Campaign launch",
            endCampaign: "Campaign end",
            createBtn: "Save",
            campaignName: "Enter a campaign Name",
            shortName: "Enter a short name",
            notDiscontinued: " -- -- --",
            from: "From",
            to: "To"
        },
        configurator: {
            label: "Configurator",
            confirmGroup: "Confirm group",
            save: "Save",
            saveClose: "Save and exit",
            warning: "Warning",
            messageAlert1: "Selection a tester",
            messageAlert2: "The path is not include into the group",
            messageAlert3: "The color configuration of this module will be reset for all planograms.",
            messageAlert4: "Please select a product.",
            messageAlert5: "Please select a ticket strip",
            close: "Close",
            cleanConf: "Clean configuration",
            product: "Product",
            ticket: "Ticket strip"
        },
        modalNavigatorIncompatible: {
            warningText:
                "Sorry, this application is, at the moment, only available on Chrome.\n" +
                "New browsers will be supported very soon. \n" +
                "Thank you for your patience.",
            confirmButtonText: "OK"
        },
        modalComponentCreate: {
            errorCreateTxt: "ERROR IN OBJECT RECORDING",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREATE A NEW COMPONENT",
            successCreateTxt: "SUCCESSFULLY CREATED",
            seeNewCancelBtnText: "SEE THE ELEMENT CREATED",
            noBasketSelected: "PLEASE CHOOSE A BASKET",
            addItemBasketError: "AN ERROR OCCURRED WHILE ADDING THIS ITEM IN THE CURRENT BASKET."
        },
        modalImportFile: {
            errorImportTxt: "IMPORT FAILED",
            errorImportCancelBtnTxt: "TRY AGAIN",
            errorImportConfirmBtnTxt: "SEE FILE ERROR LOG",
            successImportTxt: "IMPORT SUCCESS <br/>" + "{count} {componentType} imported",
            successImportConfirmBtnTxt: "OK"
        },
        wishlist: {
            title: "ADD TO MY LIST",
            title3: "MY LIST",
            title2: "Choose a list in which you want to save the article:",
            btadd: "Add into a new list",
            btnexport: "Export",
            deleteList: "Delete",
            addtolistsuccess: "Component {name} added to the list",
            messageAlertDelete: "Are you sure to delete the list",
            btYes: "Yes",
            btNo: "No"
        },
        addlist: {
            add: "Create list",
            label: "Name"
        },
        import: {
            action: "Import",
            type: "Type",
            choose: "Select a type",
            module: "Module",
            product: "Product",
            accessory: "Accessory",
            modules: "modules",
            products: "products",
            accessories: "accessories"
        },
        campaignCreate: {
            errorCreateTxt: "ERROR IN OBJECT RECORDING",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREATE A NEW CAMPAIGN",
            successCreateTxt: "SUCCESSFULLY CREATED",
            seeNewCancelBtnText: "GO BACK TO THE LIST",
            previousCampaign: "Previous campaign"
        },
        editCampaign: {
            name: "NAME",
            shortName: "SHORTNAME",
            launch: "LAUNCH DATE",
            lastCampaign: "LAST CAMPAIGN",
            end: "END DATE",
            save: "SAVE",
            delete: "DELETE",
            edit: "EDIT",
            stand: "STAND DESIGN",
            warningText: "This campaign cannot be deleted because it's being used by some components/planograms",
            updatedMessage: "Campaign Updated",
            deletedMessage: "Campaign Deleted"
        },
        standDesign: {
            edit: "Edit a design",
            name: "name",
            description: "description",
            save: "save",
            delete: "delete",
            create: "Create a design",
            type: "Type",
            chooseType: "Select a type design"
        },
        campaignList: {
            createdBy: "Created by",
            createdOn: "on",
            modifiedBy: "Modified by",
            modifiedOn: "on"
        },
        sandbox: {
            message: "Warning : This is a test site - Data stored on this site can be re-initiliazed at any time"
        },
        userrole: {
            rights: "rights",
            none: "none",
            notfound: "No user",
            superadmin: "Super administrator",
            copyToAnotherZone: "Copy to another zone",
            filterProfile: "FILTER BY PROFILE",
            filterGroup: "FILTER BY GROUP",
            selectProfile: "SELECT PROFILE",
            viewZone: "VIEW ZONE",
            isClientAdmin: "Client admin ?",
            isSuperAdmin: "Super admin ?",
            deleteFromBrand: "Are you sure you want to delete the user <b>{user}</b> from the brand <b>{brand}</b> ?",
            messageAccessBrand: "This user has access to these others brands. Click on a brand to manage this user's rights.",
            noRight: "You don't have enough right to modify this attribute."
        },
        zonerole: {
            rights: "rights",
            ref: "ref",
            type: "type",
            group: "group",
            notfound: "No zone",
            filterProfile: "FILTER BY PROFILE",
            selectProfile: "SELECT PROFILE",
            viewUser: "VIEW USER",
            disable_zone: "DISABLE ZONE",
            deleteFromBrand: "Are you sure you want to delete the zone <b>{zone}</b> from the brand <b>{brand}</b> ?",
            deleteZone: "Are you sure you want to deactivate <b>{zone}</b> from REM3RCH ?",
            messageAccessBrand: "This zone has access to these others brands. Click on a brand to manage this zone's rights."
        },
        userAdmin: {
            manage: "manage",
            access: "access",
            reset_password: "reset password",
            edit_info: "modify info",
            delete_from_brand: "delete from brand",
            disable_user: "deactivate all access",
            enable_user: "reactive all access"
        },
        zoneGroups: {
            title: "Manage zone group",
            zonesForRight: "Zones for right management",
            zonesForDashboard: "Zones to display on dashboard",
            add: "Add new group",
            deleteGroup: "Delete group",
            availableZones: "Available Zones",
            zonesToBelong: "Zones belonging to the group",
            deleteFromBrand: "Are you sure you want to delete the group <b>{group}</b> from the brand <b>{brand}</b> ?",
            copyTo: "Copy to"
        },
        brand: {
            create: "CREATE A NEW BRAND",
            createTitle: "Create a brand",
            seeNewConfirmBtnText: "CREATE A NEW BRAND",
            successCreateTxt: "SUCCESSFULLY CREATED",
            successUpdateTxt: "SUCCESSFULLY UPDATED",
            seeNewCancelBtnText: "GO BACK TO THE LIST",
            example: "EXAMPLE: RGB(XXX,XXX,XXX) OR #727A96",
            name: "Name",
            linkColor: "Links",
            fourthColor: "Tag lines",
            backgroundColor: "Background",
            rem3rchLogo: "Div Background",
            brandTheme: "Theme",
            brandHiddenPrice: "Show prices in e-store for clients",
            brandHiddenNo: "No",
            brandHiddenYes: "Yes",
            nameRequired: "Please enter a name",
            logoRequired: "Please upload a logo",
            colorTitle: "Colours",
            colorFormatInfo: "Format accepted: Name (blue), rgb(0,0,255), Hex (#0000FF)",
            removeImgButton: "Remove",
            confirmRemoveHeroImg: "Are you sure you want to remove the homepage hero image ?",
            confirmRemoveLogo: "Are you sure you want to remove the logo ?",
            removeImgSuccess: "Image removed successfully",
            currency: "currency",
            errorCurrency: "Please select the currency",
            code: "Code",
            colorsError: "One or more colours are missing or incorrect. Please fill all colours fields correctly",
            shippingMethods: "Shipping Methods",
            newShippingMethodName: "New shipping method name",
            settings: "Settings",
            navigation: {
                general: "General",
                access: "Access",
                eStore: "E-Store",
                notificationList: "Distribution List"
            }
        },
        zone: {
            create: "Create a zone",
            createNew: "Create new zone",
            brandInactive: "This brand has been removed from the zone",
            relationBetween: "Relation between {zone} and {brand} :",
            allowCatalogForecast: "Allow catalog forecast",
            allowCatalogFirmOrder: "Allow firm order",
            name: "Name",
            abbreviation: "Abbreviation",
            refClient: "Client Reference",
            description: "Description",
            save: "save",
            addZone: "Add zone",
            delete: "delete",
            errorCreateTxt: "ERROR IN OBJECT RECORDING",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREATE A NEW ZONE",
            successCreateTxt: "SUCCESSFULLY CREATED",
            seeNewCancelBtnText: "GO BACK TO THE LIST",
            noSectionSelected: "YOU NEED TO SELECT A SECTION",
            brand: "Brand",
            nameRequired: "Please enter a name",
            abbrRequired: "Please enter an abbreviation",
            sectionRequired: "Please select a section",
            copy: "Copy components from the zone/campaign",
            allZone: "All zones",
            selectZone: "Please select a zone",
            selectCampaign: "Please select a campaign",
            selectNewCampaign: "Please select a new campaign",
            copyFromZone: "Copy from Zone",
            campaignNeeded: "A campaign is required when 'All Zones' is selected.",
            newCampaignNeeded: "The new campaign is required when a reference campaign is selected.",
            copyFromZoneDesc: "Selecting a Zone only : The new zone will be created as a copy of the selected zone",
            copyFromZoneCampaign: "Copy from Zone & Campaign",
            copyFromZoneCampaignDesc:
                "Selecting a Zone and a Campaign : The new zone will be created a copy of the selected zone, all active componants will have a Launch campaign = selected Campaign",
            campaign: "Campaign",
            newCampaign: "New Campaign",
            cannot_find: "Cannot find the zone you looking for ?",
            select_zones: "Select a zone",
            section: "Section",
            createSearchMessage: "Enter a keyword (country name for example) or its code to check if this zone already exists in Rem3rch :",
            backToZoneList: "Back to zone list",
            selectIt: "Select it",
            editWarning: "Please note that changes will only take effect at the start of the next period."
        },
        launchForecast: {
            notAvailable: "This launch Forecast is no longer available",
            forecastWindow: {
                xlsDontMatch: "This excel file does not match your current forecast.<br>Please make sure you have selected the correct file.",
                redownloadXls: "Your template is out of date.<br>Please reload it."
            },
            xlsImport: {
                title: "Import XLS file",
                helpText: "Need help? Consult our instructions",
                helpLink: "here",
                browse: "BROWSE",
                upload: "UPLOAD",
                matchResult: "{matched} match(es) out of {total} component(s)",
                clientSapRef: "Client SAP ref.",
                forecastAction: "Forecast action",
                currentPrice: "Current price",
                priceToImport: "Price to import",
                priceAction: "Price action",
                forecastActionTooltip:
                    "- The reference will be added if it does not exist in FORECAST.<br>- No action will be taken if the reference already exists in Forecast.<br>- No references are deleted from Forecast via XLSX import.",
                priceActionTooltip: "Only prices for Z001 type references are imported.",
                toAdd: "To add",
                toUpdate: "To update",
                toRemove: "To remove",
                existingRef: "Existing ref",
                notImported: "Not updated",
                notImportedType: "Not imported ({type})",
                unknownRefs: "The following references are not currently in REM3RCH :",
                cancel: "CANCEL",
                startImport: "START IMPORT",
                uploadSuccess: "Xls file uploaded successfully",
                importSuccess: "Import successful",
                errorImport: "ERROR IMPORT"
            }
        },
        catalogForecast: {
            title: "catalog forecast",
            noPeriod: "No period",
            globalProgression: "global progression",
            periodOpening: "Period opening",
            forecastExported: "Forecast exported",
            firmOrderClosing: "Firm order closing",
            rechallenge: "rechallenge",
            rechallengeMarkets: "rechallenge markets",
            rechallengeMarketsModal: {
                title: "Rechallenge Markets",
                message: "Select the markets you would like to (re)submit forecasts",
                messageLabel: "Message"
            },
            market: {
                rechallenged: "Re-challenged :<br>click here to see the message :",
                saveAndSubmit: "Save and submit",
                searchItem: "Search an item",
                searchByCategory: "Search by category",
                selectCategory: "Select category",
                wasRechallenged: "was rechallenged",
                rechallengedByOn: "by {user} on {monthText} the {dayth}",
                messageLabel: "Message",
                accessMessage: "You'll be able to access the message again you're on the next page",
                nameLabel: "Name",
                unitLabel: "Unit per box",
                quotaLabel: "Quota",
                labOfficeLabel: "Lab Office",
                parentCodeLabel: "Parent code",
                switchToCatalogDateLabel: "Switch to catalog date",
                productHierarchyLabel: "Product Hierarchy",
                typeLabel: "Type",
                statusLabel: "Status",
                warningDownload: "The template has already been downloaded :",
                warningDownload2: "Are you sure you want to download it ?",
                wrongFile: "Wrong file",
                wrongFileUploaded:
                    "Wrong template : This file was downloaded from another period or for another market.<br><br>Download the template dedicated to this table, then upload it again.",
                corruptedFileUploaded: "Error : File corrupted (columns or rows modified)",
                warningUpload: "The template has already been uploaded :",
                warningUpload2: "Are you sure you want to upload it ?",
                warningUpload3: "WARNING: you will overwrite quantities already filled by another user.",
                backToDashboard: "Back to dashboard",
                reference: "reference",
                references: "references",
                noPeriod: "No period available for this market",
                noItem: "No item",
                uploadSuccess: "<b>XLS uploaded !</b><br>Quantities saved automatically",
                warningSave:
                    "You have not saved your latest changes.<br>If you leave this page without saving, you will lose the latest changes.<br><br>Do you want to quit without saving?",
                warningSaveBeforeUpload:
                    "You have not saved your latest changes.<br>Uploading a file will overwrite quantities already filled.<br><br>Do you want to continue?"
            }
        },
        brandCreate: {
            errorCreateTxt: "ERROR IN OBJECT RECORDING",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "Logout",
            successCreateTxt: "SUCCESSFULLY CREATED",
            seeNewCancelBtnText: "GO BACK TO THE LIST",
            msglogout: "You must logout to access the new brand"
        },
        versioning: {
            title: "Versioning",
            save: "Save",
            add: "Add",
            id: "id",
            version: "Version",
            name: "Name",
            date: "Date",
            description: "Description",
            action: "Action",
            edit: "Edit",
            remove: "Delete",
            messageDelete: "Warning: Are you sure? You won't be able to revert this!",
            upcoming: "Upcoming",
            createBy: "Create by"
        },
        componentType: {
            create: "CREATE A COMPONENT TYPE",
            errorCreateTxt: "ERROR IN OBJECT RECORDING",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREATE A NEW COMPONENT TYPE",
            successCreateTxt: "SUCCESSFULLY CREATED",
            seeNewCancelBtnText: "GO BACK TO THE LIST"
        },
        brandadmin: {
            name: "Name",
            access: "Access to applications",
            title: "Access to applications by brand"
        },
        menulayer: {
            title: "LAYERS"
        },
        abonnement: {
            title: "Subscription",
            brand: "Brand",
            application: "Applications",
            nbUser: "Number of users",
            nbModule: "Number of modules created since",
            nbProduct: "Number of products created since",
            nbShade: "Number of shades created since",
            diffusion: "Distribution list",
            startSub: "Start of subscription",
            endSub: "End of subscription",
            maintainDiffusion: "Manage the distribution list",
            close: "Close",
            addUserToDiffusion: "Add to diffusion list",
            previous: "Back",
            save: "save"
        },
        basket: {
            addBasketToPlano: "Add planogram to basket",
            shippingPrice: "Price : {price}", //+ SHIPPING
            deliveryDetails: "ADD TO BASKET",
            perPlano: "PER PLANOGRAM",
            units: "UNITS",
            add: "ADD TO BASKET",
            info: "This item will be added to the following basket",
            titleDetails: "Your basket",
            labelPrice: "Unit price",
            labelQuantity: "Quantity",
            labelUnit: "Unit",
            items: "items",
            removeLink: "Remove from basket",
            statusBasket: "{status} basket",
            userBasket: "Added to basket by",
            dateBasket: "on {date}",
            subTotal: "Sub total",
            noteBasket: "This price includes the cost of the parts without any shipping, discounts, or other costs",
            alertRemove: "Are you sure you would like to delete the item {item} from your basket ?",
            warning: "Warning",
            back: "Back to my basket",
            btnOrder: "Place order",
            placeOrderError: "An error has occurred while placing your order. Please try again at a later time."
        },
        messageError: {
            addName: "Please enter a basket name",
            addQuantityMultiple: "The minimum value is 1",
            select: "Please select a basket",
            reactiv: "Are you sure you want to reactivate this components ?",
            shades: "Are you sure you want to reactivate this shades ?",
            planos: "Are you sure you want to reactivate this planos ?"
        },
        eStore: {
            title: "ORDER LIST",
            name: "Name",
            brand: "Brand",
            zone: "Zone",
            status: "Status",
            last: "Last modify",
            details: "Details"
        },
        versionPlano: {
            version: "Version",
            saveBy: "Saved by"
        },
        basketMenu: {
            menuTitle: "Baskets",
            viewBasket: "View basket",
            viewAllBaskets: "View all baskets",
            noBasket: "You have no basket",
            warning: "Warning",
            deleteConfirmation: "Are you sure you would like to delete the basket {basket} ? ",
            deleteAction: "Delete",
            cancelAction: "Cancel"
        },
        displayerSystemType: {
            displayerTitle: "Displayers",
            selectSystemType: "Please select a system type"
        },
        orders: {
            historyAction: {
                delivery_address_added: "Delivery address added",
                purchase_order_added: "Purchase order added",
                delivery_address_updated: "Delivery address updated",
                purchase_order_updated: "Purchase order updated",
                shipping_method_cost_updated: "Shipping method cost updated"
            },
            title: "Order",
            deleteOrder: {
                textCancelOrder: "Are you sure you want to cancel your order ? this action cannot be undone.",
                confirmDelete: "Your order has successfully been deleted",
                hasDeleted: "This order has been deleted",
                btnListOrder: "Go to order list"
            },
            btnOrders: {
                btnPrint: "print order",
                btnCancel: "Cancel order",
                btnArchive: "Archive order",
                btnModify: "Modify"
            },
            labelStatus: "Current status",
            labelCreated: "Created on",
            labelCreatedBy: "by",
            labelLastUpdate: "Last modification",
            labelLastUpdateBy: "by",
            tableOrder: {
                element: "Element ID",
                description: "description",
                quantity: "QTY",
                plano: "Plano",
                unitPrice: "Unit price",
                totalPrice: "Total price",
                labelSubTotal: "Sub-total",
                labelShippingCost: "Shipping cost",
                labelShippingMethod: "Shipping method",
                labelShippingReference: "Shipping reference",
                labelShippingComments: "Comments",
                items: "Items",
                addShippingInfo: "Add",
                shippingInfoSuccess: "Shipping informations added.",
                errorShippingCost: "Invalid shipping costs . Please update the value of this field.",
                errorShippingMethod: "Select a shipping method.",
                validateTotalCostButton: "Validate Total Cost",
                validateTotalCostSuccess: "Total cost validated",
                errorDeliveryAddress: "Enter your delivery address"
            },
            timeline: {
                title: "Timeline"
            },
            message: {
                textMessage: "Send a message to diam + the order group",
                btnSen: "Send",
                history: "Order history"
            },
            labelPurchase: "Purchase order ref",
            timeAgo: {
                year: "{time} year(s) ago",
                month: "{time} month(s) ago",
                day: "{time} day(s) ago",
                hour: "{time} hour(s) ago",
                minute: "{time} minute(s) ago",
                second: "{time} second(s) ago"
            },
            storeInformation: {
                title: "Store information"
            },
            payments: {
                title: "Payments"
            },
            orderWindow: {
                title: "Order Window",
                unlinkedOrderMessage: "This order is not linked to an order window",
                selectButton: "Select an order window",
                listeTitle: "Select an order window",
                linkAction: "Link",
                unlinkAction: "Unlink",
                linkError: "Please select at least an order window.",
                unlinkError: "This order is not linked to any order window.",
                linkSuccess: "Order linked successfully to the order window {name}",
                unlinkSuccess: "Order removed successfully from the order window",
                linkedTitle: "This order is linked to the following order window",
                titleOrderWindowInformation: "Order window information",
                titleOrderWindowUpcoming: "Upcoming order windows",
                from: "From",
                to: "to",
                description: "Description",
                titleOrderLink: "Orders linked to the order window",
                orderId: "Order id",
                buyer: "Buyer",
                status: "Status",
                lastUpdate: "Last update",
                msgEmptyOrder: "No orders linked to this order window"
            },
            deliveryAddress: {
                title: "Delivery address",
                addDeliveryAddress: "Add delivery address",
                btnAdd: "Add",
                btnModify: "Modify",
                TitleAdd: "Enter your delivery address",
                TitleModify: "Change your delivery address"
            },
            buyerInformation: {
                title: "Buyer information"
            },
            people: {
                title: "People associated this order"
            },
            labelPurchaseOrder: "Please enter your purchase order ref for this order",
            purshaseOrderTitle: "Purchase Order",
            sendPurchaseOrder: "Send",
            addPurchaseOrderSuccess: "Purchase order added successfully",
            shipOrder: {
                title: "Ship order",
                textHeader: "If you have shipping reference, please specify it here :"
            }
        },
        notificationList: {
            recipients: "Recipients",
            list: "List",
            allUsers: "All Users",
            selectedRecipients: "Selected Recipients",
            createNewList: "Create new list",
            noDeleteListMessage:
                "This list can not be delete because it is associated with at least one application. <br> Please remove the following associations first: <br><br>{appNames}",
            confirmDeleteListMessage: "Do you really want to delete the list {name}? - This action cannot be undone",
            associationHeadline: "Applications - Distribution List Association"
        }
    },
    fr: {
        trad: "fr",
        saved: "sauvegardé",
        admin: {
            componentForm: {
                goBackButton: "Retour",
                createHead: "Créer un composant",
                editHead: "Editer un composant",
                subhead: "Marque: {{brand}}",
                componentType: "Type de composant",
                compotentTypeNames: {
                    caddy: "Caddie",
                    module: "Module",
                    product: "Produit",
                    accessory: "Accessoire",
                    divider: "Séparateur",
                    shelf: "Plateau",
                    ticketStrip: "Étiquette",
                    fascia: "Fascia",
                    frame: "Cadre",
                    ladder: "Echelle",
                    display: "Meuble",
                    blankingGraphic: "Visuels pré-vente"
                },
                name: "Nom",
                shortName: "Diminutif",
                systemType: "Type du système",
                systemTypes: {
                    caddy: "Caddie",
                    shelf: "Plateau",
                    tile: "Bloc",
                    newTile: "Nouveau bloc"
                },
                design: "Design",
                availableOn: {
                    label: "Disponible sur",
                    carcass: "Carcasse",
                    template: "Template",
                    planogram: "Planogramme"
                },
                defaultCampaign: {
                    label: "Campaigne par défaut",
                    onGoing: "En cours",
                    defaultLaunchAndDiscontinuation: "Campagne de lancement et d'arrêt par défaut",
                    zonesAndMarkets: "Zones / Marchés",
                    description: "Description",
                    status: "Status",
                    noStatus: "aucun",
                    categories: "Categories",
                    addCategory: "+ajouter une category",
                    estoreAvailability: {
                        label: "e-store",
                        unavailable: "Non disponible",
                        diamOnly: "Diam uniquement",
                        everybody: "Disponible à tous"
                    }
                },
                estore: {
                    label: "E-Store",
                    applyPrices: "Appliquer aux zones",
                    defaultPrice: "Prix par défaut",
                    estoreAvailability: {
                        label: "e-store",
                        unavailable: "Non disponible",
                        diamOnly: "Diam uniquement",
                        everybody: "Disponible à tous"
                    }
                },
                references: {
                    label: "Références"
                },
                missingProperties: "formulaire incomplet : vérifiez les champs obligatoires (indiqués par un astérisque)",
                successEditedMessage: "Composant édité avec succès"
            }
        },
        fasciaEditor: {
            colorLabel: "Couleur",
            width: "Largeur",
            height: "Hauteur"
        },
        blankingGraphicEditor: {
            width: "Largeur",
            height: "Hauteur"
        },
        frameEditor: {
            colorLabel: "Couleur",
            width: "Largeur",
            height: "Hauteur",
            thickness: "Épaisseur"
        },
        dividerEditor: {
            width: "Largeur",
            height: "Hauteur"
        },
        shelfEditor: {
            componentTypeLabel: "Type de composant"
        },
        template: {
            form: {
                loadingError: "Le form n'a pas fini de charger",
                missingError: ":name est requis mais manquant",
                name: "Nom",
                link: "Lien",
                ref: "Reference",
                zone: {
                    label: "Zone",
                    empty: "Veuillez selectionner une zone"
                },
                standDesign: {
                    label: "Stand Design",
                    empty: "Veuillez selectionner un stand design"
                },
                displayerType: {
                    label: "Displayer type",
                    empty: "Veuillez selectionner un type de displayer"
                },
                category: "Catégorie"
            }
        },
        systemTypes: {
            1: "tile",
            2: "plateau",
            3: "caddy",
            4: "nouveau tile"
        },
        error: {
            403: {
                error: "ERREUR!",
                errorText: "ACCÈS REFUSÉ"
            },
            404: {
                error: "ERREUR!",
                errorText: "PAGE NON TROUVÉ"
            }
        },
        actions: {
            confirm: "Confirmer",
            search: "Chercher",
            cancel: "Annuler",
            addUser: "Ajouter utilisateur",
            remove: "Supprimer"
        },
        changeAccess: {
            title: "Modifier l'accès",
            desactivate:
                "Êtes-vous sur de vouloir désactiver <b>{fullName}</b> de REM3RCH ? <br />" +
                "Cet utilisateur ne pourra plus accéder au site, sous aucune marque",
            activate:
                "Êtes-vous sur de vouloir ré-activer <b>{fullName}</b> sur REM3RCH ? <br />" +
                "Cet utilisateur aura de nouveau accès à toutes les marques sur lesquelles il était déclaré",
            disconnectUser: {
                title: "Votre profil a été modifié.",
                text: "Vous allez devoir vous réidentifier dans l'application."
            }
        },
        createUser: {
            title: "Ajouter un nouvel utilisateur",
            msgSearch: "Veuillez renseigner son adresse email pour vérifier si cet utilisateur possède déjà un compte sur Rem3rch :",
            hasAccessBrand: "Cet utilisateur est déjà enregistré dans Rem3rch avec un accès à {brand}",
            updateBrand: "Cet utilisateur est déjà enregistré dans Rem3rch, mais avec un accès à d'autres marques :",
            confimUpdateBrand: "Confirmez-vous un nouvel accès à la marque {brand} ?",
            InputEmpty:
                "Utilisateur inconnu dans la base de données. Merci de renseigner les champs ci-dessous pour finaliser la création de l’utilisateur",
            labelMan: "Mr",
            labelWoman: "Mme",
            labelGenre: "Genre",
            fieldsError: "Champs obligatoires",
            labelFirstName: "Prénom",
            labelLastName: "Nom",
            labelEmail: "E-mail",
            labelBrand: "Marque",
            searchIt: "Rechercher",
            backToUsersList: "Retour à la liste des utilisateurs",
            yesIConfirm: "Oui, je confirme",
            manageUserRights: "Gérer les droits utilisateur"
        },
        deleteBrand: {
            message: "Êtes-vous sûr de vouloir supprimer la marque {brand} de l’utilisateur",
            messageAction: "Cette action est irréversible.",
            msgDelete: "Vous devez vous déconnecter pour que la suppression soit prise en compte",
            confirmTitle: "ERREUR",
            warningText: "La suppression n'est pas autorisée car cette marque est déjà utilisée comme référence!"
        },
        userList: {
            title: "Utilisateurs",
            viewActiveOnly: "Voir uniquement les utilisateurs actifs",
            activateAllBrands: "Activer toutes les marques",
            brand: "Marques",
            email: "email",
            remerchAccess: "Droits REMERCH",
            lastConnection: "Dernière connexion",
            emptyList: "List vide",
            search: "Recherche",
            edit: "edit",
            delete: "delete",
            history: "history"
        },
        cguModal: {
            title: "Condition Générale d'utilisation",
            acceptButton: "Oui j'ai lu et j'accepte les terms et conditions d'utilisation",
            refuseButton: "Refuser",
            acronyme: "CGU"
        },
        checkBoxModal: {
            selectAll: "Tout Selectionner",
            selectNone: "Tout Déselectionner",
            copyButton: "Copier sur ces Zones"
        },
        StatStatus: {
            titleArchived: "Archiver/Désarchiver",
            titleChangeStatus: "Change Status",
            contentArchived: "Êtes vous sur de vouloir",
            contentStatus: "Êtes vous sur de changer le status",
            cancel: "Annuler",
            valider: "Valider",
            labelArchived: "Archiver",
            labelDesarchived: "Désarchiver"
        },
        userAccess: {
            title: "GESTION DES ACCES D'UN UTILISATEUR A UNE MARQUE",
            search: "Rechercher",
            clear: "Effacer",
            brandAccessed: "Accès aux marques suivantes: ",
            addAccess: "Ajouter à la marque en cours",
            close: "FERMER",
            super: "CET UTILISATEUR EST UN SUPER ADMIN",
            alreadyAccess: "CET UTILISATEUR A DEJA ACCES A CETTE MARQUE",
            infoSavedBrand: "N'oublier pas de donner les accès aux différentes fonctionnalitées de la marque",
            linkButton: "Gestion marque utilisateur",
            alertMessage: "Êtes-vous sur de vouloir supprimer cette marque ?"
        },
        countdown: {
            nextcntd: "Prochaines périodes promo",
            accessdenied: "Vous n'avez pas acces a cette fonctionnalité.",
            creatnewcntd: "Création nouvelle période promo",
            listcntd: "Afficher la liste",
            emptycntd: "Liste vide",
            colname: "Nom",
            colstartdate: "Date début",
            colenddate: "Date fin",
            colstanddesign: "Stand design",
            colbrand: "Marque",
            colcreateupdate: "Création/Mise à jour",
            adddesc: "Ajoutez description",
            btncreate: "Ajouter",
            btncancel: "Annuler",
            btndelete: "Supprimer",
            confirmdelete: "Êtes-vous sûr de vouloir supprimer"
        },
        preferences: {
            title: "Préférences utilisateur",
            label: {
                name: "Nom",
                userName: "Prénom",
                password: "Mot de passe",
                language: "Langue (défaut)",
                brand: "Marque (défaut)",
                zoned: "Zone (défaut)",
                stands: "Stand design (défaut)",
                campaign: "Campagne (défaut)"
            },
            option: {
                language: "Dernière valeur",
                brand: "Dernière valeur",
                zoned: "Dernière valeur",
                stands: "Dernière valeur",
                campaign: "Dernière valeur"
            },
            message: {
                valider: "Préférences enregistrées"
            },
            btn: {
                label: "Enregistrer Préférences"
            },
            terms: "Vous avez acceptez les conditions générales d'utilisations le : 05/04/2018 voir les conditions générales d'utilisation",
            subscription: "Abonnement REM3RCH : voir les détails de l'abonnement",
            successMessage: "Préférences sauvegardées"
        },
        gui: {
            form: {
                error: {
                    mandatory: "Ce champ est obligatoire",
                    integer: "Valeur attendue entier",
                    float: "Valeur attendue nombre flottant",
                    email: "Email n'est pas valide",
                    mask: "Le champ n'est pas valide"
                }
            }
        },
        plano: {
            editor: {
                confirmDeleteFavorite: "Voulez-vous vraiment supprimer le favoris?",
                generateLadders: {
                    label: "Créer des echelles",
                    subhead: "Intérieur meuble: largeur = {{width}}mm / hauteur = {{height}}mm",
                    leftPadding: "gauche (x)",
                    rightPadding: "droite (x)",
                    topPadding: "haut (y)",
                    bottomPadding: "bas (y)",
                    generatedHeight: "Hauteur totale: {{height}}",
                    generatedWidth: "Largeur totale: {{width}}"
                },
                generateFixings: {
                    label: "Créer des points d'accroches",
                    subhead: "Intérieur meuble: largeur = {{width}}mm / hauteur = {{height}}mm",
                    pickCaddyLabel: "sélectionnez votre référence de caddie",
                    horizontalCount: "répétition en largeur (x) : ",
                    verticalCount: "répétition en hauteur (y) : ",
                    spacingLabel: "espacement entre deux caddies",
                    horizontalSpacing: "largeur (x)",
                    verticalSpacing: "hauteur (y)",
                    paddingLabel: "padding extérieur",
                    leftPadding: "gauche (x)",
                    rightPadding: "droite (x)",
                    topPadding: "haut (y)",
                    bottomPadding: "bas (y)",
                    save: "sauvegarder",
                    cancel: "annuler",
                    caddyOption: "{{name}} – width: {{width}} / height: {{height}} "
                },
                moveFixings: {
                    title: "Déplacer Fixings",
                    position: "Position"
                },
                resizePaper: {
                    label: "Redimensionner le papier",
                    width: "Largeur :",
                    height: "Hauteur :",
                    direction: {
                        label: "Direction",
                        left: "Gauche",
                        center: "Centre",
                        right: "Droite"
                    },
                    ok: "Ok",
                    cancel: "Cancel"
                },
                header: {
                    file: {
                        label: "Fichier",
                        save: "Sauvegarder",
                        saveAs: "Sauvegarder Sous",
                        saveAsTemplate: "Sauvegarder en tant que template",
                        renamePlanogram: {
                            labelMenu: "Renommer",
                            labelRenamePlano: "Renommer",
                            close: "Fermer",
                            valider: "valider"
                        },
                        saveAndExit: "Sauvegarder et quitter",
                        exit: "Quitter"
                    },
                    export: {
                        label: "Export",
                        print: "Imprimer",
                        exportPdf: "Export PDF",
                        exportLdPdf: "Export LD PDF",
                        exportExcel: "Export Excel"
                    },
                    window: {
                        label: "Fenetre",
                        toolbar: "Barre d'Outils",
                        library: "Librarie",
                        dummies: "Barre de novice"
                    },
                    help: {
                        label: "Aide",
                        shortcutList: {
                            label: "Liste des raccourcis",
                            "zoom+": "Zoom +",
                            "zoom-": "Zoom -",
                            copy: "Copier",
                            paste: "Coller",
                            save: "Sauvegarder",
                            undo: "Annuler",
                            redo: "Rejouer",
                            delete: "Supprimer",
                            edit: "Editer",
                            addToFavorites: "Ajouter au favoris",
                            group: "Grouper",
                            ungroup: "Dégrouper",
                            print: "Imprimer",
                            magnet: "Activer/Désactiver le magnet",
                            toggleLayers: "Activer/Désactiver les layers",
                            toggleLibrary: "Afficher/Cacher la librarie de composants"
                        },
                        fileInfo: "Détails du fichier",
                        help: "Aide"
                    }
                },
                infoStatistic: {
                    modules: "Modules",
                    shades: "Teintes",
                    shelves: "Plateaux",
                    caddies: "Caddies"
                },
                exportPdfModal: {
                    title: "Export PDF",
                    printQuality: "Qualité",
                    lowQuality: "Basse qualité",
                    highQuality: "Haute qualité",
                    overviewPage: "Ajouter page overview",
                    shadesPage: "Ajouter page des teintes",
                    infoPage: "Ajouter informations du planogramme",
                    planoInfoTitle: "Informations planograme",
                    shadesPageTitle: "Teintes",
                    overviewPagePager: "Vue d'ensemble",
                    noShades: "Aucune teinte"
                },
                corruptedModulesModal: {
                    title: "Certains éléments sont manquants ou corrompus",
                    subTitle: "Merci de contacter l’équipe REM3RCH pour plus d'informations",
                    missingModuleMessage: "composant non disponible pour ce planogramme"
                }
            },
            template: {
                errorNoCarcass: "Au minimum une carcasse doit être présente"
            },
            lock: "En cours d'édition",
            noresult: "Désolé, aucun résultat ne correspond à votre recherche.",
            errorSetLoginAttempts: "Une erreur s’est produite : Le nombre de tentatives de connexion n’a pas pu être réinitialisé. ",
            buttonLoginAttempts: "Re-initialisation nombre de connexion",
            gotocatalogue: "catalogue",
            search_planogram: "Rechercher un planogramme",
            create: "+ Creer un planogramme",
            select_campaign: "Selectionner une campagne",
            select_campaign_label: "Campagne",
            select_campaign_ele: "TOUTES CAMPAGNES",
            select_zone_label: "Zone",
            select_zone_ele: "---",
            select_height_label: "Haut",
            select_height_ele: "---",
            select_width_label: "Larg",
            select_width_ele: "---",
            select_brand_label: "Client",
            select_stand_type_label: "Type displayer",
            select_stand_design_label: "Stand Design",
            select_brand_ele: "---",
            select_sortBy_label: "Ordre par",
            select_sortBy_ele: "---",
            duplicate_plano: "Dupliquer le planogramme",
            enter_new_name: "Entrer le nouveau nom du planogramme",
            select_zone: "Selectionner la zone",
            btn_validate: "Valider",
            name_placeholder: "Nom du planogramme",
            your_plano: "Votre planogramme",
            duplicate_message: "a bien été dupliqué sous le nom",
            open_plano: "Ourvrir le planogramme",
            note_duplicate_plano: "Note: Pensez à modifier la campagne/zone pour voir votre nouveau planogramme",
            confirmExit: {
                title: "Voulez-vous sauver les modifications apportées au planogramme {name} ?",
                message: "(Vos modifications seront perdues si vous quittez sans enregistrez)",
                dontSaveButton: "Ne pas enregistrer",
                saveButton: "Enregistrer",
                cancelButton: "Annuler"
            },
            saveAsModal: {
                saveAsLabel: "Enregistrer sous"
            },
            savePlanoAsTemplate: {
                title: "Sauvegarder en tant que template",
                label: "Nom",
                infos: {
                    title: "Infos",
                    zone: "zone",
                    standDesign: "Stand design",
                    height: "Hauteur",
                    width: "Largeur"
                }
            },
            renameFavoriteModal: {
                title: "Renommer Favoris"
            },
            infoModal: {
                informationGeneralTitle: "Informations Generales",
                informationPlanogramTitle: "Informations planogrammes",
                repartitionTitle: "Répartition",
                name: "nom",
                zone: "zone",
                designAndCampaign: "design / campagne",
                design: "design",
                size: "taille",
                type: "type",
                modulesQuantity: "Quantité totale de modules",
                shadesQuantity: "Quantité totale de teintes",
                shelvesQuantity: "Quantité totale de plateaux",
                caddiesQuantity: "Quantité total de caddies",
                modulesSku: "Modules Sku",
                shadesSku: "Shades Sku",
                shelvesSku: "Plateaux Sku",
                noHighlightColor: "Aucune couleur de surbrillance sur cette marque",
                caddySku: "Caddy Sku",
                createdOn: "Créer le",
                modifiedOn: "Dernière modification le"
            },
            caddy: {
                editor: {
                    frames: {
                        title: "frames"
                    },
                    tickets: {
                        title: "tickets"
                    },
                    fascias: {
                        title: "fascias",
                        create: "creer un nouveau fascia"
                    }
                }
            }
        },
        common: {
            open: "ouvrir",
            cancel: "Annuler",
            close: "Fermer",
            finish: "Terminer",
            footerDate: "© REM3RCH 2020",
            deconnexion: "Déconnexion",
            profil: "Mon profil",
            preferences: "Préférences",
            edit: "éditer",
            pdf: "Download PDF",
            download: "Télécharger",
            upload: "importer",
            error: "Ooops, un problème est survenu. Désolé pour ce petit contre-temps.",
            exportPDF: "Export PDF",
            search: "Recherche",
            delete: "supprimer",
            disable: "Désactiver",
            remove: "retirer",
            history: "historique",
            ok: "OK",
            save: "Sauvegarder",
            reset: "Reset",
            saveAs: "Enregistrer sous",
            versioning: "Versioning",
            create: "Créer",
            createBasket: "Créer un nouveau panier",
            ref: "Référence",
            by: "par",
            required: "Requis",
            campaign: "Campagne",
            planogram: "Planogramme",
            catalog: "Catalogue",
            brand: "Marque",
            searchAll: "Tous les composants",
            mobileNotDispo: "Cette fonctionnalité n’est pas, pour le moment, disponible sur smartphone.",
            selectAll: "Tout sélectionner",
            selectNone: "Tout déselectionner",
            resetSelection: "Réinitialiser la sélection",
            dateTimeFormat: "DD/MM/YYYY [à] HH:mm",
            yes: "oui",
            no: "non"
        },
        formErrorMessages: {
            fieldMissingMessage: "Certaines données sont incorrectes. Merci de vérifier les champs suivants.",
            emptyField: "Merci de renseigner ce champs",
            mailInvalid: "Merci de rentrer une adresse mail valide",
            fieldTooLong: "Champs trop long(Longueur toléré {maxLength})",
            color: "Merci de renseigner une couleur avec un format valide (ex: bleu, rgb(0,0,255) ou #0000FF)",
            max: "Un maximum de {max} caractères",
            min: "Au moins {min} caractères",
            isColor: "n'est pas une couleur",
            required: "requis",
            isBool: "Valeur incorrect",
            isArray: "Valeur incorrecte"
        },
        headerAdmin: {
            meuble: "PARAMETRAGE MEUBLE",
            campaign: "CREATION DE CAMPAGNE",
            list: "CAMPAGNES",
            template: "CHOIX DE TEMPLATE PLANOGRAMME",
            cpnt_management: "CREER un composant",
            displayers: "MEUBLES",
            client: "client",
            admin: "admin",
            super_admin: "super admin",
            uploadPage: "Import des composants",
            zone: {
                add: "AJOUTER UNE ZONE",
                create: "CREATION DE ZONE",
                displayDeletedZone: "Afficher les zones supprimées",
                client_ref: "ref client",
                name: "nom",
                type: "type",
                group: "groupe",
                brands: "marques",
                users: "utilisateurs",
                edit_type: "éditer type",
                parameters: "paramètres",
                deleted: "supprimée"
            },
            design: "DESIGNS",
            brand: "Marque",
            zoneList: "ZONES",
            zone_group: {
                manage: "gérer groupe de zone"
            },
            componentList: "COMPONENT TYPE",
            user: "USERS"
        },
        menuCatalogStar: {
            linkViewFeattured: "Voir produits à la une",
            linkViewAll: "Voir tous le catalogue"
        },
        dashboardModule: {
            catalogTitle: "Catalogue",
            planoTitle: "Planogrammes",
            catSubTitle: "derniers modifications",
            featureTitle: "à la une",
            myOrdersTitle: "Mes commandes",
            planoSubTitle: "dernières modifications",
            newItem: "Create nouveau",
            seeAllCat: "Accéder au catalogue",
            seeAllPlanos: "Voir tous les planogrammes",
            seeAllOrders: "Voir toutes mes commandes",
            open: "Ouvrir",
            option: "Options",
            changeBrand: "Changer de marque",
            changeZone: "Changer de zone",
            changeCampaign: "Changer de campagne",
            allCampaign: "Toutes campagnes",
            allCampaignShort: "Toutes camp.",
            information: "Informations",
            info: "Infos",
            thOrderID: "ID commande",
            thBuyer: "Acheteur",
            thLastActivity: "Dernière Activité",
            thStatus: "Statut"
        },
        menuHeader: {
            homeLink: "Accueil",
            catalogueLink: "Catalogue",
            planoLink: "Plano builder",
            planosLink: "Planos",
            forecastLink: "Launch Forecast",
            catalogForecastLink: "Catalog Forecast",
            tools: {
                name: "tools",
                manageUsers: "manage users",
                manageZones: "manage zones",
                manageCampaigns: "manage campaigns",
                exportExcel: "archive export"
            },
            menu: "Menu",
            selectBrand: "Sélecctionner une marque",
            selectZone: "Sélectionner une zone",
            selectCampaign: "Sélectionner une campagne",
            godMode: "Mode Dieu",
            help: "Aide"
        },
        help: {
            title: "Aide",
            catalog: "catalogue",
            launch_forecast: "launch forecast",
            catalog_forecast: "catalogue forecast",
            tools: "tools",
            uploadPdf: "Importer<br>PDF",
            uploadPdfError: "Erreur lors de l'import PDF",
            noFile: "Aucun fichier",
            newPdf: "Ajouter un nouveau PDF",
            newVideo: "Ajouter une nouvelle vidéo",
            filter: "Filtre",
            category: "Catégorie",
            howTo: "Comment faire",
            videoTraining: "Formation vidéo",
            noItem: "Pas d'élément dans cette catégorie"
        },
        shades: {
            title: "Teintes",
            allActive: "Teintes actives de la Zone",
            zoneShades: "Toutes les teintes de la Zone",
            allShades: "Toutes les teintes",
            add: "AJOUTER UNE TEINTE",
            edit: "Editer",
            noShades: "désolé, aucune teinte disponible",
            import: "IMPORTER DES TEINTES",
            label: "teintes",
            certified: "Teinte certifiée",
            color: "Couleur",
            campaignL: "Campagne de lancement",
            msgResultSearch: "Votre recherche retourne <span>{result}</span> résultat",
            afterDelete: "Cette teinte n'est utilisée sur aucun planogramme",
            confirmDelete: "Confirmer la suppression",
            deleteWarning: "Cette teinte est utilisée dans le(s) planogramme(s) suivant :",
            btndelete: "Supprimer",
            form: {
                name: "Veuillez entrer un nom",
                ref1: "Veuillez entrer la ref 'client ref1'"
            }
        },
        product: {
            back: "Retour aux résultats de la recherche",
            notPublished: "[Non publié]",
            articleInfos: "Informations article",
            zoneCampaignInfos: "INFORMATIONS ZONES ET CAMPAGNES",
            description: "Description",
            price: "* Prix public conseillé",
            relatedProduct: "Produits associés",
            productsModule: "Modules pour ce produit",
            manage: "Gérer les associations",
            launch: "Lancement",
            discontinued: "Discontinué",
            noComponent: "Non disponible dans la campagne et/ou zone sélectionnée",
            publish: "Publier",
            ticket: "Gestion des tickets strip",
            errorCompagn: "Vous devez sélectionner une campagne",
            labelLancement: "Campagne de lancement",
            labelDiscontinuer: "Discontinuer",
            labelSelectZone: "Selectionner la zone",
            labelCertif: "Teinte certifiée",
            deleteModal: {
                confirmTitle: "Supprimer ce composant ?",
                warningText: "Êtes-vous de vouloir supprimer ? Vous ne pourrez plus revenir en arrière!",
                confirmDelete: "Oui, supprimer!"
            }
        },
        contentPage: {
            backToSearch: "Retour",
            btnEdit: "Éditer"
        },
        catalogue: {
            clear: "Effacer filtres",
            weFound: "Votre recherche",
            results: "Résultats",
            for: "pour",
            return: "retourne",
            tri: "trier",
            filter: "filtrer",
            allCampaign: "Toutes campagnes",
            allZonesAbr: "all",
            allZonesDesc: "",
            allZonesName: "Toutes zones",
            exportpdf: "AJOUTER DANS EXPORT PDF",
            basket: "AJOUTER AU PANIER",
            comment: "Commentaire",
            status: "Status",
            none: "Aucun",
            updateStatusButton: "Changer status",
            updateStatusSuccess: "Status mis à jour",
            systemType: "Type de système",
            filters: {
                component: "Composants",
                standDesign: "Stand Design",
                status: "Status",
                systemType: "Système",
                starred: "Favoris",
                published: "Publié",
                categories: "Catégories",
                sections: "Sections"
            }
        },
        login: {
            forgot: "Mot de passe oublié ?"
        },
        modulePage: {
            infosArticle: "Informations article",
            description: "Description",
            productsModule: "Produits présents dans le module",
            moduleProduct: "Module contenant ce produit",
            ticketStrips: "Etiquettes",
            allTickets: "Voir toutes les étiquettes"
        },
        change: {
            selectBrand: "Sélectionner une marque"
        },
        meublePlano: {
            save: "Sauvegarder",
            numberOfBlocs: "Nombre de séparations",
            blocWidth: "Largeur des blocs",
            setBloc: "Définir les blocs",
            stripSize: "Taille du bandeau",
            segmentation: "Segmentation",
            name: "Nom",
            title: "Paramétrage meuble planogramme",
            externalSize: "Dimensions extérieures",
            internalSize: "Dimensions internes",
            width: "Largeur",
            height: "Hauteur",
            header: "Header",
            footer: "Base",
            planoModule: "Cadre intérieur",
            pitchH: "Pas horizontal",
            pitchR: "Nombre de répétitions",
            pitchV: "Pas vertical",
            remainingSpaceH: "Espace restant horizontalement",
            remainingSpaceV: "Espace restant verticalement",
            error: "La combinaison pas x répétitions excède la taille du meuble",
            errorSetStandDesign: "Vous devez spécifier un stand design"
        },
        templatePlano: {
            type: "Type",
            size: "Size",
            template: "Template",
            summary: "Summary",
            createTitle: "Créer un planogramme",
            planoName: "Entrez un titre pour le planogramme",
            zone: "Zone",
            standDesign: "Stand Design",
            zoneTitle: "Sélectionner une zone",
            brand: "Marque",
            brandTitle: "Sélectionner une marque",
            campaign: "Sélectionner une campagne",
            sizeTitle: "Sélectionner les dimensions du planogramme",
            templateTitle: "Sélectionner le template du planogamme",
            planoName: "Nom du planogramme",
            campaignS: "Campagne",
            planoSize: "Dimensions du planogramme",
            planoTemp: "Template du planogramme",
            send: "Enregistrer",
            nextStep: "Etape suivante",
            previousStep: "Etape précédente",
            title: "Nom du planogramme",
            width: "Largeur",
            widthTitle: "Sélectionner une largeur",
            height: "Hauteur",
            heightTitle: "Sélectionner une hauteur",
            NoSizesAvailable: "Aucun résultat trouvé. Merci de revenir à l’écran précédent et de modifier votre sélection."
        },
        planoSelect: {
            edit: "Editer",
            duplicate: "Dupliquer",
            move: "Déplacer",
            addToFavorite: "Ajouter aux favoris",
            addToScratchpad: "Placer dans scratchpad",
            group: "Grouper",
            deleteModule: "Supprimer",
            ungroup: "Dégrouper",
            ungroupall: "Dégrouper tout",
            addComment: "Ajouter un commentaire"
        },
        favorite: {
            title: "Enregistrer en tant que favoris",
            name: "Entrer le nom du favoris",
            save: "Enregistrer",
            noFavorite: "Aucun favori ajouté"
        },
        commentPanel: {
            title: "Notes / Commentaires",
            personalNoteTitle: "Note Personnelle",
            removePersonalNote: "supprimer",
            send: "Envoyer le commentaire",
            addComment: "Ajouter un commentaire",
            addPersonalNote: "Ajouter en note personnel",
            allComments: "Voir tous les commantaires",
            reply: "Réponses",
            asOpened: "Marquer comme non résolu",
            asClosed: "Marquer comme résolu",
            includePdf: "Mettre commentaires dans PDF",
            excludePdf: "Retirer commentaires du PDF",
            confirmDelete: "Êtes-vous sûr de vouloir supprimer cette note personelle ?",
            deleteAction: "Supprimer",
            updateCommentMessage: "Commentaire mis à jour avec succès",
            updateCommentErrorMessage: "Une erreur est survenue lors de la mise à jour de votre commentaire",
            newCommentMessage: "Commentaire ajouté avec succès",
            newCommentErrorMessage: "Une erreur est survenue lors de la création de votre commentaire",
            deletePersonalNoteSuccessMessage: "Note supprimée avec succès",
            deleteCommentErrorMessage: "Une erreur est survenue lors de la suppression de votre note",
            replySubCommentPh: "Répondre...",
            newCommentPh: "Votre note / commentaire",
            replyButton: "Répondre"
        },
        comments: {
            send: "Envoyer le commentaire"
        },
        headerPlano: {
            cancel: "Annuler",
            saveExit: "Sauvegarder et quitter",
            save: "Sauvegarder",
            back: "Retour"
        },
        planoList: {
            planogram: "Planogrammes",
            lock: "en cours d'édition par",
            created: "Crée le",
            modified: "Modifié le",
            by: "Par",
            visibility: "Visibilité",
            comments: "Commentaires",
            option: "Options",
            duplicate: "Duplication",
            delete: "Supprimer",
            submitted: "Soumis",
            in_progress: "En cours",
            approved: "Approuve",
            history: "Historique des versions",
            editName: "Editer Nom",
            order: {
                level: "Niveau",
                cd_asc: "Date de création CROISSANT",
                cd_desc: "Date de création DECROISSANT",
                md_asc: "Date de modification CROISSANT",
                md_desc: "Date de modification DECROISSANT",
                camp_asc: "Date de campagne CROISSANT",
                camp_desc: "Date de campagne DECROISSANT",
                h_asc: "Hauteur CROISSANT",
                h_desc: "Hauteur DECROISSANT",
                w_asc: "Largeur CROISSANT",
                w_desc: "Largeur DECROISSANT"
            }
        },
        planobuilder: {
            export: "export",
            support: "aide",
            comment: "commentaires",
            favorite: "favoris",
            scratch: "scratchpad",
            library: "bibliothèque",
            shades: "teintes",
            ticketStrip: "Ticket strip",
            saveShades: "sauvegarder",
            cancelShades: "Annuler",
            view: "Affichage",
            hide: "Cacher",
            by: "Crée par",
            modifiedBy: "Modifié par",
            on: "le",
            blackwhite: "Noir & Blanc",
            iconscolors: "Teintes",
            shadesRef: "Références",
            realistic: "Realiste",
            frameHide: "Accessoires",
            highlights: "Highlights",
            messageAlert: "A fin d'afficher le planogramme dans une autre langue, une sauvegarde va être effectuée",
            messageAlert1: "Ce ticket strip n'est pas rattaché à ce module.",
            messageAlert2: "On ne peut pas mettre un module a cette position elle est déjà occupé",
            messageAlert3: "Le module ne doit pas sortir du plano",
            warning: "Attention",
            layer: "Calques",
            modules: "Modules",
            reference: "Reference",
            selection: "Sélection",
            pan: "Pan",
            ungroupall: "Dégroup all",
            zoomIn: "Zoomé",
            zoomOut: "Dézoomé",
            zoomModule: "Zoom sur module",
            posInit: "position initiale du module",
            exportPreview: "Export PDF avec mise en page",
            exportPDF: "Direct Export PDF",
            exportXLS: "Export XLS",
            highDefinition: "Haute résolution",
            lowDefinition: "Basse résolution",
            popinModuleErrorTitle: "Attention les modules suivants ne sont pas disponibles pour cette zone et cette campagne:"
        },
        crudComponent: {
            name: "nom",
            uses: "Types d'utilisations",
            nameEnRequired: "Veuillez saisir le nom en anglais",
            nameFrRequired: "Veuillez saisir le nom en français",
            nickname: "nom pour plano",
            nicknameEnRequired: "Veuillez saisir le nom pour plano en anglais",
            nicknameFrRequired: "Veuillez saisir le nom pour plano en français",
            description: "description",
            descriptionEnRequired: "Veuillez saisir la description en anglais",
            descriptionFrRequired: "Veuillez saisir la description en français",
            type: "Type plano",
            chooseBrand: "Marque sélectionnée",
            chooseCategory: "Choisir une catégorie / Sous catégorie",
            chooseStatus: "Choisir un status",
            selectCategory: "Choisir une catégorie",
            selectStatus: "Choisir un status",
            selectSubCat: "Choisir une sous-catégorie",
            categoryRequired: "Veuillez choisir une catégorie",
            addCategory: "Ajouter une catégorie",
            removeCategory: "Supprimer une catégorie",
            choosedefaultCampaign: "Choisir une campagne par défaut",
            launchDate: "Campagne de lancement",
            standDesign: "Stand Design",
            discontinued: "Discontinuer",
            selectCampaign: "Sélectionner une campagne",
            addProperties: "Ajout de propriétés",
            title: "Créer un composant",
            eStoreTypeTitle: "Disponibilité e-Store",
            chooseSystemType: "Choisir un type de système",
            applyPrices: "Appliquer"
        },
        eStoreType: {
            nobody: "Pas disponible",
            everybody: "Tout le monde",
            diam: "Utilisateurs Diam uniquement"
        },
        displayer: {
            create: "Création meuble",
            filters: "filtres",
            delete: "Supprimer",
            edit: "Editer"
        },
        imgEditor: {
            delete: "Supprimer",
            addPicture: "Ajouter/Modifier une photo",
            close: "Fermer",
            save: "Sauvegarder",
            infoDrag: "Vous pouvez re-organiser l'ordre des images par glisser-déposer",
            labelImg: "Chargez une nouvelle image",
            labelSelect: "Sélectionnez le type d'image",
            invalidFormat: "Format d'image non supporté : merci de charger un fichier png, jpg ou svg.",
            noImage: "Merci de charger une image avant d'enregistrer."
        },
        modalComment: {
            noComment: "Aucun commentaires sur ce plannogramme"
        },
        related: {
            showOnly: "montrer seulement les Modules dans les mêmes catégories / sous-catégories",
            search: "Rechercher"
        },
        scratchPad: {
            noScratch: "Aucun élément ajouté au scratchpad"
        },
        exportPdfPlano: {
            iconLayout: "Aperçu",
            page: "Page",
            export: "Exporter PDF",
            close: "Fermer",
            exportXls: "Exporter XLS"
        },
        duplicatePlano: {
            saveName: "Ce nom existe déjà dans la base",
            enterName: "Saisir un nom pour le plano duppliqué",
            selectCampaign: "Veuillez sélectionner une campagne",
            selectZone: "Veuillez sélectionner une zone"
        },
        component: {
            configurator: "Configurateur module",
            imgEditor: "Editeur images",
            notPublished: "Non publié",
            categories: "Catégories",
            subCat: "Sous Catégories",
            nickname: "Diminutif",
            typeComponentForPlano: "Type plano",
            nameEn: "Nom EN",
            nameFr: "Nom FR",
            moduleConfifured: "Module configuré le {date} par {user}",
            moduleLastModified: "Configuration mis à jour le {date} par {user}",
            savePrices: "Enregistre prix",
            cancel: "Annuler"
        },
        campaign: {
            create: "Création de campagne",
            brand: "Sélectionner une marque",
            standDesign: "Stand design",
            selectStandDesign: "Sélectionner une stand design",
            startCampaign: "Début de campagne",
            endCampaign: "Fin de campagne",
            createBtn: "Sauvegarder",
            campaignName: "Saisir le nom de la campagne",
            shortName: "Saisir le diminutif",
            notDiscontinued: " -- -- --",
            from: "De",
            to: "À"
        },
        configurator: {
            label: "Configurateur",
            confirmGroup: "Confirmer groupe",
            save: "Enregistrer",
            saveClose: "Enregistrer et quitter",
            warning: "Attention",
            messageAlert1: "Sélectionne un testeur",
            messageAlert2: "Le path n'est pas inclus dans le groupe",
            messageAlert3: "La configuration couleur de ce module vas être remise a zéro pour tous les planogrammes.",
            messageAlert4: "Veuillez selectionner un produit.",
            messageAlert5: "Veuillez selectionner un ticker strip",
            close: "Annuler",
            cleanConf: "Nettoyer la configuration",
            product: "Produit",
            ticket: "Ticket strip"
        },
        modalNavigatorIncompatible: {
            warningText:
                "Cette application est, pour le moment, seulement disponible sur Chrome.\n" +
                "D’autres navigateurs seront inclus très bientôt.\n" +
                "Merci pour votre compréhension et votre patience durant cette période.",
            confirmButtonText: "OK"
        },
        modalComponentCreate: {
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UN NOUVEAU COMPOSANT",
            successCreateTxt: "ENREGISTRE AVEC SUCCES",
            seeNewCancelBtnText: "VOIR L'ÉLÉMENT CRÉÉ",
            noBasketSelected: "VEUILLEZ CHOISIR UN PANIER",
            addItemBasketError: "Une erreur est survenue lors de l'ajout de cet article dans le panier. Veuillez réessayer plus tard."
        },
        modalImportFile: {
            errorImportTxt: "ÉCHEC DE L'IMPORTATION",
            errorImportCancelBtnTxt: "RÉESSAYER",
            errorImportConfirmBtnTxt: "VOIR LE FICHIER D'ERREURS",
            successImportTxt: "SUCCÈS D'IMPORTATION <br />" + "{count} {componentType} importées",
            successImportConfirmBtnTxt: "OK"
        },
        wishlist: {
            title: "AJOUTER A MA LISTE",
            title3: "MA LISTE",
            title2: "Choisir une liste dans la quelle vous voulez sauver l'article:",
            btadd: "Ajouter une nouvelle liste",
            btnexport: "Exporter",
            deleteList: "Supprimer",
            addtolistsuccess: "Composant {name} ajouté à la liste",
            messageAlertDelete: "Êtes vous sur de supprimer la liste",
            btYes: "Oui",
            btNo: "Non"
        },
        addlist: {
            add: "Créer liste",
            label: "Nom"
        },
        import: {
            action: "Importer",
            type: "Type",
            choose: "Sélectionner un type",
            module: "Module",
            product: "Produit",
            accessory: "Accessoire",
            modules: "modules",
            products: "produits",
            accessories: "accessoires"
        },
        campaignCreate: {
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UNE NOUVELLE CAMPAGNE",
            successCreateTxt: "ENREGISTRE AVEC SUCCES",
            seeNewCancelBtnText: "RETOUR A LA LISTE",
            previousCampaign: "Campagne précédente"
        },
        editCampaign: {
            name: "NOM",
            shortName: "DIMINUTIF",
            launch: "DATE DE LANCEMENT",
            lastCampaign: "DERNIERE CAMPAIGN",
            end: "DATE DE FIN",
            save: "ENREGISTRER",
            delete: "SUPPRIMER",
            edit: "EDITER",
            stand: "STAND DESIGN",
            warningText: "Cette campagne ne peut être supprimée car elle est utilisée en référence par des composants et/ou planogrammes!",
            updatedMessage: "Campagne mis à jour",
            deletedMessage: "Campagne Supprimée"
        },
        standDesign: {
            edit: "Editer un design",
            name: "nom",
            description: "description",
            save: "sauvegarder",
            delete: "supprimer",
            create: "Créer un design",
            type: "Type de design",
            chooseType: "Selectionnez un type de design"
        },
        campaignList: {
            createdBy: "Créé par",
            createdOn: "le",
            modifiedBy: "Modifié par",
            modifiedOn: "le"
        },
        sandbox: {
            message: "Attention : Site de test - Les données enregistrées sur ce site peuvent être ré-initialiser à tout moment."
        },
        userrole: {
            rights: "droits",
            none: "aucun",
            notfound: "Aucun utilisateur",
            superadmin: "Super administrateur",
            copyToAnotherZone: "Copier sur d'autres Zones",
            filterProfile: "FILTRER PAR PROFIL",
            filterGroup: "FILTRER PAR GROUPE",
            selectProfile: "SELECTIONNER PROFIL",
            viewZone: "VOIR ZONE",
            isClientAdmin: "Admin client ?",
            isSuperAdmin: "Super admin ?",
            deleteFromBrand: "Êtes-vous sûr de vouloir supprimer l'utilisateur <b>{user}</b> de la marque <b>{brand}</b> ?",
            messageAccessBrand: "Cet utilisateur a un accès vers ces autres marques. Cliquer sur une marque pour gérer ses droits d'utilisateur.",
            noRight: "Vous ne possédez pas les droits nécessaires pour modifier cet attribut."
        },
        zonerole: {
            rights: "droits",
            ref: "ref",
            type: "type",
            group: "groupe",
            notfound: "Aucune zone",
            filterProfile: "FILTRER PAR PROFIL",
            selectProfile: "SELECTIONNER PROFIL",
            viewUser: "VOIR L'UTILISATEUR",
            disable_zone: "DÉSACTIVER LA ZONE",
            deleteFromBrand: "Êtes-vous sûr de vouloir supprimer la zone <b>{zone}</b> de la marque <b>{brand}</b> ?",
            deleteZone: "Êtes-vous sur de vouloir désactiver <b>{zone}</b> de REM3RCH ?",
            messageAccessBrand: "Cette zone a un accès vers ces autres marques. Cliquer sur une marque pour gérer ses droits de zone."
        },
        userAdmin: {
            manage: "gestion",
            access: "accès",
            reset_password: "réinitialiser mot de passe",
            edit_info: "modifier info",
            delete_from_brand: "supprimer de la marque",
            disable_user: "désactiver tous les accès",
            enable_user: "réactiver tous les accès"
        },
        zoneGroups: {
            title: "Gestion groupe de zone",
            zonesForRight: "Zones pour la gestion de droits",
            zonesForDashboard: "Zones à afficher sur le dashborad",
            add: "Ajouter un nouveau groupe",
            deleteGroup: "Supprimer groupe",
            availableZones: "Zones disponibles",
            zonesToBelong: "Zones appartenant au groupe",
            deleteFromBrand: "Êtes-vous sûr de vouloir supprimer le groupe <b>{group}</b> de la marque <b>{brand}</b> ?",
            copyTo: "Copier dans"
        },
        brand: {
            create: "CREER UNE NOUVELLE MARQUE",
            createTitle: "Création de marque",
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UNE NOUVELLE MARQUE",
            successCreateTxt: "Enregistrée avec succès",
            successUpdateTxt: "Marque mise à jour avec succès",
            seeNewCancelBtnText: "RETOUR A LA LISTE",
            example: "EXEMPLE: RGB(XXX,XXX,XXX) OU #727A96",
            name: "Nom",
            linkColor: "Liens",
            fourthColor: "Tag lines",
            backgroundColor: "Fond",
            rem3rchLogo: "Div background",
            brandTheme: "Thème",
            brandHiddenPrice: "Afficher prix pour clients",
            brandHiddenNo: "Non",
            brandHiddenYes: "Oui",
            nameRequired: "Veuillez renseigner un nom de marque",
            logoRequired: "Veuillez insérer un logo",
            colorTitle: "Couleurs",
            colorFormatInfo: "Format accepté: Name (blue), rgb(0,0,255), Hex (#0000FF)",
            removeImgButton: "Retirer",
            confirmRemoveHeroImg: "Êtes-vous sur de vouloir retirer l’image hero de la page d’accueil ?",
            confirmRemoveLogo: "Êtes-vous sur de vouloir retirer le logo ?",
            removeImgSuccess: "Image supprimée",
            currency: "Devise",
            errorCurrency: "Veuillez choisir une devise",
            code: "Code",
            colorsError: "Certaines couleurs sont manquantes ou incorrectes. Merci de les renseigner.",
            shippingMethods: "Modes d'expédition",
            newShippingMethodName: "Nom du nouveau mode d'expédition",
            settings: "Preferences",
            navigation: {
                general: "General",
                access: "Accès",
                eStore: "E-store",
                notificationList: "Liste de distribution"
            }
        },
        zone: {
            create: "Création de zone",
            createNew: "Créer une nouvelle zone",
            brandInactive: "Cette marque a été supprimée de la zone",
            relationBetween: "Relation entre {zone} et {brand} :",
            allowCatalogForecast: "Autoriser catalogue forecast",
            allowCatalogFirmOrder: "Autoriser firm order",
            name: "Nom",
            abbreviation: "Abbréviation",
            refClient: "Référence Client",
            description: "Description",
            save: "Enregistrer",
            addZone: "Ajouter zone",
            delete: "Supprimer",
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UNE NOUVELLE ZONE",
            successCreateTxt: "ENREGISTRE AVEC SUCCES",
            seeNewCancelBtnText: "RETOUR A LA LISTE",
            noSectionSelected: "VOUS DEVEZ SELECTIONNER UNE SECTION",
            brand: "Marque",
            nameRequired: "Veuillez renseigner un nom de zone",
            abbrRequired: "Veuillez renseigner une abbréviation",
            sectionRequired: "Veuillez sélectionner une section",
            campaignNeeded: "Une campagne est obligatoire lorsque 'Toutes Zones' est sélectionnée",
            newCampaignNeeded: "La nouvelle campagne est obligatoire lorsque une campagne de référence est sélectionnée",
            copy: "Copier les composants de la zone/campagne suivante",
            allZone: "Toutes zones",
            selectZone: "Veuillez sélectionner une zone",
            selectCampaign: "Veuillez sélectionner une campagne",
            selectNewCampaign: "Veuillez sélectionner une nouvelle campagne",
            copyFromZone: "Copier à partir d'une zone",
            copyFromZoneDesc: "En choisssant une Zone , la nouvelle Zone sera créée à l’identique de la Zone sélectionnée.",
            copyFromZoneCampaign: "Copier à partir d'une Zone et d'une Campagne",
            copyFromZoneCampaignDesc:
                "En choisissant une Zone et une Campagne, la nouvelle Zone sera créée à l’identique de la Zone sélectionnée et tous les composants auront comme Campagne de lancement = la Campagne sélectionnée.",
            campaign: "Campagne",
            newCampaign: "Nouvelle Campagne",
            cannot_find: "Vous ne trouvez pas la zone recherchée ?",
            select_zones: "Sélectionnez une zone",
            section: "Section",
            createSearchMessage: "Renseigner un mot-clé (un pays par exemple) ou son code pour vérifier sur cette zone existe déjà dans Rem3rch :",
            backToZoneList: "Retour à la liste des zones",
            selectIt: "Sélectionner",
            editWarning: "Attention, les modifications ne prendront effet qu'à l'ouverture de la prochaine période."
        },
        launchForecast: {
            notAvailable: "Ce launch Forecast n'est plus disponible",
            forecastWindow: {
                xlsDontMatch:
                    "Ce fichier excel ne correspond pas au Forecast actuel.<br>Veuillez vous assurer que vous avez sélectionné le bon fichier.",
                redownloadXls: "Votre template n'est pas à jour.<br>Merci de le recharger."
            },
            xlsImport: {
                title: "Import fichier XLS",
                helpText: "Besoin d'aide ? Consultez nos instructions",
                helpLink: "ici",
                browse: "PARCOURIR",
                upload: "TELECHARGER",
                matchResult: "{matched} correspondance(s) sur {total} composant(s)",
                clientSapRef: "Réf. client SAP",
                forecastAction: "Action Forecast",
                currentPrice: "Prix actuel",
                priceToImport: "Prix à importer",
                priceAction: "Action prix",
                forecastActionTooltip:
                    "- La référence sera ajoutée si elle n'existe pas dans le FORECAST.<br>- Aucune action ne sera commise si la référence existe déjà dans le Forecast.<br>- Aucune référence n'est effacée du Forecast via l'import XLSX.",
                priceActionTooltip: "Seuls les prix sur les références de type Z001 sont importés.",
                toAdd: "A ajouter",
                toUpdate: "A modifier",
                toRemove: "A supprimer",
                existingRef: "Réf existante",
                notImported: "Non modifié",
                notImportedType: "Non importé ({type})",
                unknownRefs: "Les références suivantes ne sont pas actuellement dans REM3RCH :",
                cancel: "ANNULER",
                startImport: "LANCER L'IMPORT",
                uploadSuccess: "Fichier XLS envoyé avec succès",
                importSuccess: "Import réussi",
                errorImport: "ERREUR IMPORT"
            }
        },
        catalogForecast: {
            title: "catalogue forecast",
            noPeriod: "Aucune période",
            globalProgression: "Progression globale",
            periodOpening: "Ouverture période",
            forecastExported: "Forecast exporté",
            firmOrderClosing: "Fermeture commande ferme",
            rechallengeMarkets: "Rechallenger les marchés",
            rechallenge: "rechallenger",
            rechallengeMarketsModal: {
                title: "rechallenger les marchés",
                message: "Sélectionner les marchés où vous voudriez (re)soumettre les forecasts",
                messageLabel: "Message"
            },
            market: {
                rechallenged: "(Re)challengé :<br>cliquer ici pour voir le message :",
                saveAndSubmit: "Sauvegarder et soumettre",
                searchItem: "Rechercher un article",
                searchByCategory: "Rechercher par categorie",
                selectCategory: "Selectionner categorie",
                wasRechallenged: "a été rechallengé",
                rechallengedByOn: "par {user} le {day}/{month}",
                messageLabel: "Message",
                accessMessage: "Vous pourrez à nouveau accéder au message sur la page suivante",
                nameLabel: "Nom",
                unitLabel: "Pièce par carton",
                quotaLabel: "Quota",
                labOfficeLabel: "Lab Office",
                parentCodeLabel: "Code parent",
                switchToCatalogDateLabel: "Date de switch dans le catalogue",
                productHierarchyLabel: "Hiérarchie Produit",
                typeLabel: "Type",
                statusLabel: "Statut",
                warningDownload: "Le template a déjà été téléchargé :",
                warningDownload2: "Êtes-vous sûr de vouloir le télécharger ?",
                wrongFile: "Mauvais fichier",
                wrongFileUploaded:
                    "Mauvais template : ce fichier a été téléchargé depuis une autre période ou pour un autre marché.<br><br>Téléchargez le template dédié à ce tableau, puis importez-le à nouveau.",
                corruptedFileUploaded: "Erreur : Fichier corrompu (colonnes ou lignes modifiées)",
                warningUpload: "Le template a déjà été importé :",
                warningUpload2: "Êtes-vous sûr de vouloir l'importer ?",
                warningUpload3: "ATTENTION : vous écraserez les quantitées déjà renseignées par un autre utilisateur.",
                backToDashboard: "Retour au dashboard",
                reference: "référence",
                references: "références",
                noPeriod: "Aucune période disponible pour ce marché",
                noItem: "Aucun article",
                uploadSuccess: "<b>XLS importé !</b><br>Quantités sauvegardées automatiquement",
                warningSave:
                    "Vous n'avez pas enregistré vos dernières modifications.<br>Si vous quitter cette page sans enregistrer, vous perdrez les dernières modifications.<br><br>Voulez-vous quitter sans enregistrer ?",
                warningSaveBeforeUpload:
                    "Vous n'avez pas enregistré vos dernières modifications.<br>L'import d'un fichier va écraser les saisies déjà faites.<br><br>Voulez-vous continuer ?"
            }
        },
        brandCreate: {
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "Déconnexion",
            successCreateTxt: "ENREGISTRE AVEC SUCCES",
            seeNewCancelBtnText: "RETOUR A LA LISTE",
            msglogout: "Vous devez vous déconnecter pour acceder à la nouvelle marque"
        },
        versioning: {
            title: "Versioning",
            save: "Enregistrer",
            add: "Ajouter",
            id: "Id",
            version: "Version",
            name: "Nom",
            date: "Date",
            description: "Description",
            action: "Action",
            edit: "Editer",
            remove: "Supprimer",
            messageDelete: "Attenion: Êtes vous sur de vouloir supprimer le versioning?",
            upcoming: "Upcoming",
            createBy: "Créer par"
        },
        componentType: {
            create: "CREER UN COMPONENT TYPE",
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UNE NOUVELLE COMPONENT TYPE",
            successCreateTxt: "ENREGISTRE AVEC SUCCES",
            seeNewCancelBtnText: "RETOUR A LA LISTE"
        },
        brandadmin: {
            name: "Nom",
            access: "Accès aux fonctionnalités",
            title: "Accès aux applications par marque"
        },
        menulayer: {
            title: "CALQUES"
        },
        abonnement: {
            title: "Abonnement",
            brand: "Marque",
            application: "Applications",
            nbUser: "Nombre d'utilisateur",
            nbModule: "Nombre de nouveau module créé depuis le",
            nbProduct: "Nombre de nouveau produit créé depuis le",
            nbShade: "Nombre de nouvelles teintes créées depuis le",
            diffusion: "Liste de diffusion",
            startSub: "Début",
            endSub: "Fin",
            maintainDiffusion: "Gérer la liste de diffusion",
            close: "Fermer",
            addUserToDiffusion: "Ajouter destinataire",
            previous: "Précédant",
            save: "Enregistrer"
        },
        basket: {
            addBasketToPlano: "Ajouter un planogramme au panier",
            shippingPrice: "Prix : {price} + FRAIS D'ENVOI",
            deliveryDetails: "AJOUTER AU PANIER",
            perPlano: "PAR PLANOGRAMME",
            units: "UNITES",
            add: "AJOUTER AU PANIER",
            info: "Ce module sera ajouté au panier suivant",
            titleDetails: "Votre panier",
            labelPrice: "Prix unitaire",
            labelQuantity: "Quantité",
            labelUnit: "unité",
            items: "articles",
            removeLink: "Retirer du panier",
            statusBasket: "panier {status}",
            userBasket: "Ajouté au panier par",
            dateBasket: "le {date}",
            subTotal: "Sous total",
            noteBasket: "Ce prix inclus le coût des articles, sans livraison, remise, ou autres coûts",
            alertRemove: "Êtes vous sûr(e) de vouloir supprimer {item} de votre panier ?",
            warning: "Attention",
            back: "Retour à mon panier",
            btnOrder: "Passer la commande",
            placeOrderError: "Une erreur est survenue lors de la validation de votre panier. Veuillez réessayer plus tard."
        },
        messageError: {
            addName: "Veuillez saisir un nom de panier",
            addQuantityMultiple: "La valeur minimale est 1",
            select: "Veuillez sélectionner un panier",
            reactiv: "Êtes-vous sur de vouloir réactiver les composants suivants ?",
            shades: "Êtes-vous sur de vouloir réactiver les teintes suivantes ?",
            planos: "Êtes-vous sur de vouloir réactiver les planogrammes suivants ?"
        },
        eStore: {
            title: "LISTE DES ORDERS",
            name: "Nom",
            brand: "Marque",
            zone: "Zone",
            status: "Status",
            last: "Dernière modification",
            details: "Détails"
        },
        versionPlano: {
            version: "Version",
            saveBy: "Sauvegardé par"
        },
        basketMenu: {
            menuTitle: "Paniers",
            viewBasket: "Voir panier",
            viewAllBaskets: "Tous les paniers",
            noBasket: "Aucun panier",
            warning: "Attention",
            deleteConfirmation: "Êtes vous sûr(e) de vouloir supprimer le panier {basket} ?",
            deleteAction: "Supprimer",
            cancelAction: "Annuler"
        },
        displayerSystemType: {
            displayerTitle: "Meubles",
            selectSystemType: "Merci de choisir un type de système"
        },
        orders: {
            historyAction: {
                delivery_address_added: "adresse de livraison ajoutée",
                purchase_order_added: "bon de commande ajouté",
                delivery_address_updated: "adresse de livraison modifiée",
                purchase_order_updated: "bon de commande modifé",
                shipping_method_cost_updated: "détails de livraison modifiés"
            },
            title: "Commande",
            deleteOrder: {
                textCancelOrder: "Êtes-vous sur de vouloir annuler votre commande ? Cette action est irreversible.",
                confirmDelete: "Votre commande a été supprimée",
                hasDeleted: "Cette commande a été supprimée",
                btnListOrder: "Aller à la liste de commandes"
            },
            btnOrders: {
                btnPrint: "imprimer la commande",
                btnCancel: "annuler commande",
                btnArchive: "archiver commande",
                btnModify: "Modifier"
            },
            labelStatus: "Statut actuel ",
            labelCreated: "créé le",
            labelCreatedBy: "par",
            labelLastUpdate: "Dernière modification le",
            labelLastUpdateBy: "par",
            tableOrder: {
                element: "Element ID",
                description: "description",
                quantity: "QTY",
                plano: "Plano",
                unitPrice: "Unit price",
                totalPrice: "Total price",
                labelSubTotal: "Sub-total",
                labelShippingCost: "Frais de livraison",
                labelShippingMethod: "Méthode de livraison",
                labelShippingReference: "Référence d'expédition",
                labelShippingComments: "Commentaires",
                items: "Items",
                addShippingInfo: "Ajouter",
                shippingInfoSuccess: "Informations de livraison ajoutées.",
                errorShippingCost: "Frais de livraison non valides. Merci de modifier la valeur de ce champs.",
                errorShippingMethod: "Sélectionnez un moyen de livraison.",
                validateTotalCostButton: "Validez le prix total",
                validateTotalCostSuccess: "Prix total de la commande validé",
                errorDeliveryAddress: "Renseigner votre adresse de livraison"
            },
            timeline: {
                title: "étapes"
            },
            message: {
                textMessage: "Envoyer un message à diam + le groupe de commande",
                btnSen: "Send",
                history: "Order history"
            },
            labelPurchase: "Numéro de commande",
            timeAgo: {
                year: "il y a {time} ans",
                month: "il y a {time} mois",
                day: "il y a {time} jour(s)",
                hour: "il y a {time} heure(s)",
                minute: "il y a {time} minute(s)",
                second: "il y a {time} second(s)"
            },
            storeInformation: {
                title: "Information de commande"
            },
            payments: {
                title: "paiements"
            },
            orderWindow: {
                title: "Fenêtre de commande",
                unlinkedOrderMessage: "Cette commande n'est liée à aucune fenêtre de commande",
                selectButton: "Choisir une fenêtre de commande",
                listeTitle: "Choisir une fenêtre de commande",
                linkAction: "Lier",
                unlinkAction: "Retirer",
                linkError: "Merci de choisir au moins une fenêtre de commande",
                unlinkError: "Cette commande n'est rattachée a aucune fenêtre de commande",
                linkSuccess: "Commande liée à la fenêtre de commande {name} avec succès",
                unlinkSuccess: "Commande retirée de la fenêtre de commande avec succès",
                linkedTitle: "Cette commande est rattachée à l'order window suivant",
                titleOrderWindowInformation: "informations de la fenêtre de commande",
                titleOrderWindowUpcoming: "prochaines fenêtres de commande",
                from: "De",
                to: "à",
                description: "Description",
                titleOrderLink: "commandes liées à la fenêtre de commande",
                orderId: "Ref. Commande",
                buyer: "acheteur",
                status: "statut",
                lastUpdate: "demière mise à jour",
                msgEmptyOrder: "pas de commandes liées à cette fenêtre de commande."
            },
            deliveryAddress: {
                title: "Adresse de livraison",
                addDeliveryAddress: "Ajouter une adresse de livraison",
                btnAdd: "Ajouter",
                btnModify: "Modifier",
                TitleAdd: "Renseigner votre adresse de livraison",
                TitleModify: "Modifier votre adresse de livraison"
            },
            buyerInformation: {
                title: "Informations acheteur"
            },
            people: {
                title: "Personnes associées à cette commande"
            },
            labelPurchaseOrder: "Veuillez saisir votre référence de commande pour ces commandes",
            purshaseOrderTitle: "Référence de commande",
            sendPurchaseOrder: "Envoyer",
            addPurchaseOrderSuccess: "Référence de commande ajoutée avec succès",
            shipOrder: {
                title: "Ship order",
                textHeader: "Si vous avez une référence d'expédition, veuillez l'indiquer ici :"
            }
        },
        notificationList: {
            recipients: "destinataires",
            list: "liste",
            allUsers: "tous les utilisateurs",
            selectedRecipients: "destinataires sélectionnés",
            createNewList: "créer une nouvelle liste",
            noDeleteListMessage:
                "Cette liste ne peut être supprimer car elle est associée avec au moins une application. <br> Veuillez désassocier les applications suivantes : <br><br>{appNames}",
            confirmDeleteListMessage: "Êtes vous sur de supprimer la liste {name}? Cette action n'est pas réversible.",
            associationHeadline: "Associations des listes aux applications"
        }
    },
    it: {
        trad: "it",
        error: {
            403: {
                error: "ERREUR!",
                errorText: "ACCÈS REFUSÉ"
            },
            404: {
                error: "ERREUR!",
                errorText: "PAGE NON TROUVÉ"
            }
        },
        gui: {
            form: {
                error: {
                    mandatory: "Ce champ est obligatoire",
                    integer: "Valeur attendue entier",
                    float: "Valeur attendue nombre flottant",
                    email: "Email n'est pas valide",
                    mask: "Le champ n'est pas valide"
                }
            }
        },
        plano: {
            lock: "En cours d édition",
            noresult: "Désolé, aucun résultat ne correspond à votre recherche.",
            gotocatalogue: "catalogue",
            search_planogram: "Rechercher un planogramme",
            create: "+ Creer un planogramme",
            select_campaign: "Selectionner une campagne",
            select_campaign_label: "Campagne",
            select_campaign_ele: "TOUTES CAMPAGNES",
            select_zone_label: "Zone",
            select_zone_ele: "---",
            select_height_label: "Haut",
            select_height_ele: "---",
            select_width_label: "Larg",
            select_width_ele: "---",
            select_brand_label: "Client",
            select_stand_type_label: "Type displayer",
            select_stand_design_label: "Stand Design",
            select_brand_ele: "---",
            select_sortBy_label: "Ordre par",
            select_sortBy_ele: "---",
            duplicate_plano: "Dupliquer le planogramme",
            enter_new_name: "Entrer le nouveau nom du planogramme",
            select_zone: "Selectionner la zone",
            btn_validate: "Valider",
            name_placeholder: "Nom du planogramme",
            your_plano: "Votre planogramme",
            duplicate_message: "a bien été dupliqué sous le nom",
            open_plano: "Ourvrir le planogramme",
            note_duplicate_plano: "Note: Pensez à modifier la campagne/zone pour voir votre nouveau planogramme"
        },
        common: {
            open: "ouvrir",
            cancel: "Annuler",
            close: "Fermer",
            finish: "Terminer",
            footerDate: "© REM3RCH 2020",
            deconnexion: "Déconnexion",
            profil: "Mon profil",
            preferences: "Préférences",
            edit: "éditer",
            pdf: "Download PDF",
            download: "Télécharger",
            upload: "importer",
            error: "Un problème est survenu. Désolé pour ce petit contre-temps",
            exportPDF: "Export PDF",
            search: "Recherche",
            delete: "supprimer",
            disable: "Désactiver",
            remove: "retirer",
            history: "historique",
            ok: "OK",
            save: "Sauvegarder",
            reset: "Reset",
            saveAs: "Enregistrer sous",
            versioning: "Versioning",
            required: "Requis",
            campaign: "Campagne",
            planogram: "Planogram",
            catalog: "Catalog",
            searchAll: "Search all component",
            selectNone: "Tout déselectionner",
            resetSelection: "Réinitialiser la sélection",
            dateTimeFormat: "DD/MM/YYYY [à] HH:mm",
            yes: "oui",
            no: "non"
        },
        formErrorMessages: {
            emptyField: "Merci de renseigner ce champs",
            mailInvalid: "Merci de renseigner une adresse mail valide",
            fieldTooLong: "Champs trop long(Longueur toléré {maxLength})",
            color: "Merci de renseigner une couleur avec un format valide (ex: bleu, rgb(0,0,255) ou #0000FF)"
        },
        headerAdmin: {
            meuble: "PARAMETRAGE MEUBLE",
            campaign: "CREATION DE CAMPAGNE",
            list: "CAMPAGNES",
            template: "CHOIX DE TEMPLATE PLANOGRAMME",
            cpnt_management: "CREER un composant",
            displayers: "MEUBLES",
            client: "client",
            admin: "admin",
            super_admin: "super admin",
            uploadPage: "Import des composants",
            zone: {
                add: "AJOUTER UNE ZONE",
                create: "CREATION DE ZONE",
                displayDeletedZone: "Afficher les zones supprimées",
                client_ref: "ref client",
                name: "nom",
                type: "type",
                group: "groupe",
                brands: "marques",
                users: "utilisateurs",
                edit_type: "éditer type",
                parameters: "paramètres",
                deleted: "supprimée"
            },
            design: "DESIGNS",
            brand: "Marque",
            zoneList: "ZONES",
            zone_group: {
                manage: "gérer groupe de zone"
            },
            componentList: "COMPONENT TYPE"
        },
        menuCatalogStar: {
            linkViewFeattured: "View featured",
            linkViewAll: "View all"
        },
        dashboardModule: {
            catalogTitle: "Catalogue",
            planoTitle: "Planogrammes",
            catSubTitle: "derniers modifications",
            featureTitle: "Feature",
            planoSubTitle: "dernières modifications",
            newItem: "Create nouveau",
            seeAllCat: "Voir tout le catalogue",
            seeAllPlanos: "Voir tous les planogrammes",
            open: "Ouvrir",
            option: "Options",
            changeBrand: "Changer de marque",
            changeZone: "Changer de zone",
            changeCampaign: "Changer de campagne",
            allCampaign: "Toutes campagnes",
            information: "Informations",
            info: "Infos"
        },
        menuHeader: {
            homeLink: "Accoglienza",
            catalogueLink: "Catalogo",
            planoLink: "Plano builder",
            planosLink: "Planos",
            forecastLink: "Launch Forecast",
            catalogForecastLink: "Catalog Forecast",
            tools: {
                name: "tools",
                manageUsers: "manage users",
                manageZones: "manage zones",
                manageCampaigns: "manage campaigns",
                exportExcel: "archive export"
            },
            menu: "Menu",
            selectBrand: "Sélecctionner une marque",
            selectZone: "Sélectionner une zone",
            selectCampaign: "Sélectionner une campagne",
            help: "Aide"
        },
        help: {
            title: "Help",
            catalog: "catalog",
            launch_forecast: "launch forecast",
            catalog_forecast: "catalog forecast",
            tools: "tools",
            uploadPdf: "Upload<br>PDF",
            uploadPdfError: "Upload PDF error",
            noFile: "No file"
        },
        shades: {
            title: "SHADES",
            allActive: "Teintes actives de la Zone",
            zoneShades: "Toutes les teintes de la Zone",
            allShades: "Toutes les teintes",
            edit: "AJOUTER UNE TEINTE",
            noShades: "désolé, aucune teinte disponible",
            import: "IMPORTER DES TEINTES",
            label: "teintes",
            color: "Couleur",
            campaignL: "Campagne de lancement",
            afterDelete: "Cette teinte n'est utilisée sur aucun planogramme",
            confirmDelete: "Confirmer la suppression",
            deleteWarning: "Cette teinte est utilisée dans le(s) planogramme(s) suivant :",
            btndelete: "Supprimer",
            form: {
                name: "Veuillez entrer un nom",
                ref1: "Veuillez entrer la ref 'client ref1'"
            }
        },
        product: {
            back: "Retour aux résultats de la recherche",
            notPublished: "[Non publié]",
            articleInfos: "Informations article",
            zoneCampaignInfos: "INFORMATIONS ZONES ET CAMPAGNES",
            description: "Description",
            price: "* Prix public conseillé",
            relatedProduct: "Produits associés",
            productsModule: "Modules pour ce produit",
            manage: "Gérer les associations",
            launch: "Lancement",
            discontinued: "Discontinué",
            noComponent: "Non disponible dans la campagne et/ou zone sélectionnée",
            publish: "Publier",
            ticket: "Gestion des tickets strip"
        },
        contentPage: {
            backToSearch: "Retour",
            btnEdit: "Éditer"
        },
        catalogue: {
            clear: "Effacer filtres",
            weFound: "Votre recherche",
            results: "Résultats",
            for: "pour",
            return: "retourne",
            tri: "trier",
            filter: "filtrer",
            horsCampaign: "Toutes campagnes",
            allZonesAbr: "all",
            allZonesDesc: "",
            allZonesName: "Toutes zones",
            exportpdf: "AJOUTER DANS EXPORT PDF",
            comment: "Commentaire",
            systemType: "Type de système",
            filters: {
                component: "Composants",
                standDesign: "Stand Design",
                status: "Status",
                systemType: "Système",
                starred: "Favoris",
                published: "Publié",
                categories: "Catégories",
                sections: "Sections"
            }
        },
        login: {
            forgot: "Mot de passe oublié ?"
        },
        modulePage: {
            infosArticle: "Informations article",
            description: "Description",
            productsModule: "Produits présents dans le module",
            moduleProduct: "Module contenant ce produit",
            ticketStrips: "Etiquettes",
            allTickets: "Voir toutes les étiquettes"
        },
        change: {
            selectBrand: "Sélectionner une marque"
        },
        meublePlano: {
            save: "Sauvegarder",
            numberOfBlocs: "Nombre de séparations",
            blocWidth: "Largeur des blocs",
            setBloc: "Définir les blocs",
            stripSize: "Taille du bandeau",
            segmentation: "Segmentation",
            name: "Nom",
            title: "Paramétrage meuble planogramme",
            externalSize: "Dimensions extérieures",
            internalSize: "Dimensions internes",
            width: "Largeur",
            height: "Hauteur",
            header: "Header",
            footer: "Base",
            planoModule: "Cadre intérieur",
            pitchH: "Pas horizontal",
            pitchR: "Nombre de répétitions",
            pitchV: "Pas vertical",
            remainingSpaceH: "Espace restant horizontalement",
            remainingSpaceV: "Espace restant verticalement",
            error: "La combinaison pas x répétitions excède la taille du meuble",
            errorSetStandDesign: "Vous devez spécifier un stand design"
        },
        templatePlano: {
            type: "Type",
            size: "Size",
            template: "Template",
            summary: "Summary",
            createTitle: "Créer un planogramme",
            planoName: "Entrez un titre pour le planogramme",
            zone: "Zone",
            standDesign: "Stand Design",
            zoneTitle: "Sélectionner une zone",
            brand: "Marque",
            brandTitle: "Sélectionner une marque",
            campaign: "Sélectionner une campagne",
            sizeTitle: "Sélectionner les dimensions du planogramme",
            templateTitle: "Sélectionner le template du planogamme",
            planoName: "Nom du planogramme",
            campaignS: "Campagne",
            planoSize: "Dimensions du planogramme",
            planoTemp: "Template du planogramme",
            send: "Enregistrer",
            nextStep: "Etape suivante",
            previousStep: "Etape précédente",
            title: "Nom du planogramme",
            width: "Largeur",
            widthTitle: "Sélectionner une largeur",
            height: "Hauteur",
            heightTitle: "Sélectionner une hauteur"
        },
        planoSelect: {
            edit: "Editer",
            duplicate: "Dupliquer",
            move: "Déplacer",
            addToFavorite: "Ajouter aux favoris",
            addToScratchpad: "Placer dans scratchpad",
            group: "Grouper",
            deleteModule: "Supprimer",
            ungroup: "Dégrouper",
            ungroupall: "Dégrouper tout"
        },
        favorite: {
            title: "Enregistrer en tant que favoris",
            name: "Entrer le nom du favoris",
            save: "Enregistrer",
            noFavorite: "Aucun favori"
        },
        commentPanel: {
            title: "Notes / Comments",
            personalNoteTitle: "Personal Note",
            removePersonalNote: "remove",
            send: "Send comment",
            addComment: "Add Comment",
            addPersonalNote: "Save as a Personal Note",
            allComments: "View all comments",
            reply: "Replies",
            asResolve: "Tag as Resolved",
            asUnResolve: "Tag as Unresolved",
            includePdf: "Include comment in PDf",
            excludePdf: "Remove comment from PDf",
            confirmDelete: "Are you sure to delete this Personal Note ?",
            deleteAction: "Delete",
            updateCommentMessage: "Comment updated succesfully",
            updateCommentErrorMessage: "An error occurred while updating your comment",
            newCommentMessage: "New comment added succesfully",
            newCommentErrorMessage: "An error occurred while saving your comment",
            replySubCommentPh: "Your reply",
            newCommentPh: "Your note / comment",
            replyButton: "Reply"
        },
        comments: {
            send: "Envoyer le commentaire"
        },
        headerPlano: {
            cancel: "Annuler",
            saveExit: "Sauvegarder et quitter",
            save: "Sauvegarder",
            back: "Retour"
        },
        planoList: {
            planogram: "Planogrammes",
            lock: "en cours d édition par",
            created: "Crée le",
            modified: "Modifié le",
            by: "Par",
            visibility: "Visibilité",
            comments: "Commentaires",
            option: "Options",
            duplicate: "Duplication",
            delete: "Supprimer",
            submitted: "Soumis",
            in_progress: "En cours",
            approved: "Approuve",
            history: "Dernières versions",
            order: {
                level: "Niveau",
                cd_asc: "Date de création CROISSANT",
                cd_desc: "Date de création DECROISSANT",
                md_asc: "Date de modification CROISSANT",
                md_desc: "Date de modification DECROISSANT",
                camp_asc: "Date de campagne CROISSANT",
                camp_desc: "Date de campagne DECROISSANT",
                h_asc: "Hauteur CROISSANT",
                h_desc: "Hauteur DECROISSANT",
                w_asc: "Largeur CROISSANT",
                w_desc: "Largeur DECROISSANT"
            }
        },
        planobuilder: {
            export: "export",
            support: "aide",
            comment: "commentaires",
            favorite: "favoris",
            scratch: "scratchpad",
            library: "bibliothèque",
            shades: "teintes",
            ticketStrip: "Ticket strip",
            saveShades: "sauvegarder",
            cancelShades: "Annuler",
            view: "Affichage",
            hide: "Cacher",
            by: "Crée par",
            modifiedBy: "Modifié par",
            on: "le",
            blackwhite: "Noir & Blanc",
            iconscolors: "Teintes",
            shadesRef: "Références",
            realistic: "Realiste",
            frameHide: "Accessoires",
            highlights: "Highlights",
            messageAlert: "A fin d'afficher le planogramme dans une autre langue, une sauvegarde va être effectuée",
            messageAlert1: "Ce ticket strip n'est pas rattaché à ce module.",
            messageAlert2: "On ne peut pas mettre un module a cette position elle est déjà occupé",
            messageAlert3: "Le module ne doit pas sortir du plano",
            warning: "Attention",
            layer: "Calques",
            modules: "Modules",
            reference: "Reference",
            selection: "Sélection",
            pan: "Pan",
            ungroupall: "Dégroup all",
            zoomIn: "Zoomé",
            zoomOut: "Dézoomé",
            zoomModule: "Zoom sur module",
            posInit: "position initiale du module",
            highlightsShade: {
                menu: {
                    blue: "Bleu",
                    red: "Rouge",
                    yellow: "Jaune",
                    green: "Vert",
                    violet: "Violet",
                    none: "Aucun"
                }
            }
        },
        crudComponent: {
            name: "nom",
            nameEnRequired: "Veuillez saisir le nom en anglais",
            nameFrRequired: "Veuillez saisir le nom en français",
            nickname: "nom pour plano",
            nicknameEnRequired: "Veuillez saisir le nom pour plano en anglais",
            nicknameFrRequired: "Veuillez saisir le nom pour plano en français",
            description: "description",
            descriptionEnRequired: "Veuillez saisir la description en anglais",
            descriptionFrRequired: "Veuillez saisir la description en français",
            type: "Type plano",
            chooseBrand: "Marque sélectionnée",
            chooseCategory: "Choisir une catégorie / Sous catégorie",
            chooseStatus: "Choisir un status",
            selectCategory: "Choisir une catégorie",
            selectStatus: "Choisir un status",
            selectSubCat: "Choisir une sous-catégorie",
            categoryRequired: "Veuillez choisir une catégorie",
            addCategory: "Ajouter une catégorie",
            removeCategory: "Supprimer une catégorie",
            choosedefaultCampaign: "Choisir une campagne par défaut",
            launchDate: "Campagne de lancement",
            standDesign: "Stand Design",
            discontinued: "Discontinuer",
            selectCampaign: "Sélectionner une campagne",
            addProperties: "Ajout de propriétés",
            title: "Créer un composant",
            eStoreTypeTitle: "Disponibilité e-Store",
            chooseSystemType: "Choisir un type de système"
        },
        eStoreType: {
            nobody: "Personne",
            everybody: "Tout le monde",
            diam: "Utilisateurs Diam uniquement"
        },
        displayer: {
            create: "Création meuble",
            filters: "filtres",
            delete: "Supprimer",
            edit: "Editer"
        },
        imgEditor: {
            delete: "Supprimer",
            addPicture: "Ajouter/Modifier une photo",
            close: "Fermer",
            save: "Sauvegarder",
            invalidFormat: "Format d'image non supporté : merci de charger un fichier png, jpg ou svg.",
            noImage: "Merci de charger une image avant d'enregistrer."
        },
        modalComment: {
            noComment: "Aucun commentaires sur ce plannogramme"
        },
        related: {
            showOnly: "montrer seulement les Modules dans les mêmes catégories / sous-catégories",
            search: "Rechercher"
        },
        scratchPad: {
            noScratch: "Aucun élément ajouté au scratchpad"
        },
        exportPdfPlano: {
            iconLayout: "Aperçu",
            page: "Page",
            export: "Exporter PDF",
            close: "Fermer",
            exportXls: "Exporter XLS"
        },
        duplicatePlano: {
            saveName: "Ce nom existe déjà dans la base",
            enterName: "Saisir un nom pour le plano duppliqué",
            selectCampaign: "Veuillez sélectionner une campagne",
            selectZone: "Veuillez sélectionner une zone"
        },
        component: {
            configurator: "Configurateur module",
            imgEditor: "Editeur images",
            notPublished: "Non publié",
            categories: "Catégories",
            subCat: "Sous Catégories",
            nameEn: "Nom EN",
            nameFr: "Nom FR"
        },
        campaign: {
            create: "Création de campagne",
            brand: "Sélectionner une marque",
            standDesign: "Stand design",
            selectStandDesign: "Sélectionner une stand design",
            startCampaign: "Début de campagne",
            endCampaign: "Fin de campagne",
            createBtn: "Sauvegarder",
            campaignName: "Saisir le nom de la campagne",
            shortName: "Saisir le diminutif"
        },
        configurator: {
            label: "Configurator",
            confirmGroup: "Confirmer groupe",
            save: "Enregistrer",
            saveClose: "Enregistrer et quitter",
            warning: "Attention",
            messageAlert1: "Sélectionne un testeur",
            messageAlert2: "Le path n'est pas inclus dans le groupe",
            messageAlert3: "La configuration couleur de ce module vas être remise a zéro pour tous les planogrammes.",
            messageAlert4: "Attention: il faut selectionner un produit.",
            messageAlert5: "Attention; il faut selectionner au moin un ticker strip",
            close: "Annuler",
            cleanConf: "Nettoyer la configuration",
            product: "Produit",
            ticket: "Ticket strip"
        },
        modalNavigatorIncompatible: {
            warningText:
                "Cette application est, pour le moment, seulement disponible sur Chrome.\n" +
                "D’autres navigateurs seront inclus très bientôt.\n" +
                "Merci pour votre compréhension et votre patience durant cette période.",
            confirmButtonText: "OK"
        },
        modalComponentCreate: {
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UN NOUVEAU COMPOSANT",
            successCreateTxt: "ENREGISTRE AVEC SUCCES",
            seeNewCancelBtnText: "VOIR L'ÉLÉMENT CRÉÉ",
            noBasketSelected: "VEUILLEZ CHOISIR UN PANIER",
            addItemBasketError: "UNE ERREUR EST SURVENUE LORS DE L'AJOUT DE CET ARTICLE DANS LE PANIER. VEUILLEZ RÉESSAYER PLUS TARD."
        },
        modalImportFile: {
            errorImportTxt: "ÉCHEC DE L'IMPORTATION",
            errorImportCancelBtnTxt: "RÉESSAYER",
            errorImportConfirmBtnTxt: "VOIR LE FICHIER D'ERREURS",
            successImportTxt: "SUCCÈS D'IMPORTATION <br />" + "{count} {componentType} importées",
            successImportConfirmBtnTxt: "OK"
        },
        wishlist: {
            title: "AJOUTER A MA LISTE",
            title3: "MA LISTE",
            title2: "Choisir une liste dans la quelle vous voulez sauver l'article:",
            btadd: "Ajouter une nouvelle liste",
            btnexport: "Exporter",
            deleteList: "Supprimer",
            addtolistsuccess: "Composant {name} ajouté à la liste",
            messageAlertDelete: "Êtes vous sur de supprimer la liste",
            btYes: "Oui",
            btNo: "Non"
        },
        addlist: {
            add: "Créer liste",
            label: "Nom"
        },
        import: {
            action: "Importer",
            type: "Type",
            choose: "Sélectionner un type",
            module: "Module",
            product: "Produit",
            accessory: "Accessoire",
            modules: "modules",
            products: "produits",
            accessories: "accessoires"
        },
        campaignCreate: {
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UNE NOUVELLE CAMPAGNE",
            successCreateTxt: "ENREGISTRE AVEC SUCCES",
            seeNewCancelBtnText: "RETOUR A LA LISTE"
        },
        editCampaign: {
            name: "NOM",
            shortName: "DIMINUTIF",
            launch: "DATE DE LANCEMENT",
            lastCampaign: "DERNIERE CAMPAIGN",
            end: "DATE DE FIN",
            save: "ENREGISTRER",
            delete: "SUPPRIMER",
            edit: "EDITER",
            stand: "STAND DESIGN",
            warningText: "Cette campagne ne peut être supprimée car elle est utilisée en référence par des composants et/ou planogrammes!"
        },
        standDesign: {
            edit: "editer un design",
            name: "nom",
            description: "description",
            save: "sauvegarder",
            delete: "supprimer",
            create: "Créer un design",
            type: "Type de design",
            chooseType: "Selectionnez un type de design"
        },
        campaignList: {
            createdBy: "Créé par",
            createdOn: "le",
            modifiedBy: "Modifié le",
            modifiedOn: "le"
        },
        sandbox: {
            message: "Attention : Site de test - Les données enregistrées sur ce site peuvent être ré-initialiser à tout moment."
        },
        userrole: {
            rights: "droits",
            none: "aucun",
            notfound: "Aucun utilisateur",
            superadmin: "Super administrateur",
            copyToAnotherZone: "Copier sur d'autres zones",
            filterProfile: "FILTRER PAR PROFIL",
            filterGroup: "FILTRER PAR GROUPE",
            selectProfile: "SELECTIONNER PROFIL",
            viewZone: "VOIR ZONE",
            isClientAdmin: "Admin client ?",
            isSuperAdmin: "Super admin ?",
            deleteFromBrand: "Êtes-vous sûr de vouloir supprimer l'utilisateur <b>{user}</b> de la marque <b>{brand}</b> ?",
            messageAccessBrand: "Cet utilisateur a un accès vers ces autres marques. Cliquer sur une marque pour gérer ses droits d'utilisateur.",
            noRight: "Vous ne possédez pas les droits nécessaires pour modifier cet attribut."
        },
        zonerole: {
            rights: "droits",
            ref: "ref",
            type: "type",
            group: "groupe",
            notfound: "Aucune zone",
            filterProfile: "FILTRER PAR PROFIL",
            selectProfile: "SELECTIONNER PROFIL",
            viewUser: "VOIR L'UTILISATEUR",
            disable_zone: "Désactiver la ZONE",
            deleteFromBrand: "Êtes-vous sûr de vouloir supprimer la zone <b>{zone}</b> de la marque <b>{brand}</b> ?",
            deleteZone: "Êtes-vous sur de vouloir désactiver <b>{zone}</b> de REM3RCH ?",
            messageAccessBrand: "Cette zone a un accès vers ces autres marques. Cliquer sur une marque pour gérer ses droits de zone."
        },
        userAdmin: {
            manage: "gestion",
            access: "accès",
            reset_password: "réinitialiser mot de passe",
            edit_info: "modifier info",
            delete_from_brand: "supprimer de la marque",
            disable_user: "désactiver tous les accès",
            enable_user: "réactiver tous les accès"
        },
        zoneGroups: {
            title: "Gestion groupe de zone",
            zonesForRight: "Zones pour la gestion de droits",
            zonesForDashboard: "Zones à afficher sur le dashborad",
            add: "Ajouter un nouveau groupe",
            deleteGroup: "Supprimer groupe",
            availableZones: "Zones disponibles",
            zonesToBelong: "Zones appartenant au groupe",
            deleteFromBrand: "Êtes-vous sûr de vouloir supprimer le groupe <b>{group}</b> de la marque <b>{brand}</b> ?",
            copyTo: "Copier dans"
        },
        brand: {
            create: "CREER UNE NOUVELLE MARQUE",
            createTitle: "Création de marque",
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UNE NOUVELLE MARQUE",
            successCreateTxt: "Marque créée avec succès",
            successUpdateTxt: "Marque mise à jour avec succès",
            seeNewCancelBtnText: "RETOUR A LA LISTE",
            example: "EXEMPLE: RGB(XXX,XXX,XXX) OU #727A96",
            name: "Nom",
            linkColor: "Couleurs des liens",
            backgroundColor: "Couleur de fond",
            rem3rchLogo: "Fond Div",
            brandTheme: "Theme",
            brandHiddenPrice: "Afficher prix pour clients",
            brandHiddenNo: "Non",
            brandHiddenYes: "Oui",
            nameRequired: "Veuillez renseigner un nom de marque",
            logoRequired: "Veuillez insérer un logo",
            errorCurrency: "Veuillez choisir une devise",
            code: "Code"
        },
        zone: {
            create: "Création de zone",
            createNew: "Créer une nouvelle zone",
            brandInactive: "Cette marque a été supprimée de la zone",
            relationBetween: "Relation entre {zone} et {brand} :",
            allowCatalogForecast: "Autoriser catalogue forecast",
            allowCatalogFirmOrder: "Autoriser firm order",
            name: "Nom",
            abbreviation: "Abbreviation",
            refClient: "Reference Client",
            description: "Description",
            save: "Enregistrer",
            addZone: "Ajouter zone",
            delete: "Supprimer",
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UNE NOUVELLE ZONE",
            successCreateTxt: "ENREGISTRE AVEC SUCCES",
            seeNewCancelBtnText: "RETOUR A LA LISTE",
            noSectionSelected: "VOUS DEVEZ SELECTIONNER UNE SECTION",
            brand: "Marque",
            nameRequired: "Veuillez renseigner un nom de zone",
            abbrRequired: "Veuillez renseigner une abbréviation",
            sectionRequired: "Veuillez sélectionner une section",
            editWarning: "Please note that changes will only take effect at the start of the next period."
        },
        brandCreate: {
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UNE NOUVELLE MARQUE",
            successCreateTxt: "ENREGISTRE AVEC SUCCES",
            seeNewCancelBtnText: "RETOUR A LA LISTE"
        },
        versioning: {
            title: "Versioning",
            save: "Enregistrer",
            add: "Ajouter",
            id: "Id",
            version: "Version",
            name: "Nom",
            date: "Date",
            description: "Description",
            action: "Action",
            edit: "Editer",
            remove: "Supprimer",
            messageDelete: "Attenion: Êtes vous sur de vouloir supprimer le versioning?",
            upcoming: "Upcoming",
            createBy: "Créer par"
        },
        componentType: {
            create: "CREER UN COMPONENT TYPE",
            errorCreateTxt: "ERREUR DANS L'ENREGISTREMENT OBJET",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREER UNE NOUVELLE COMPONENT TYPE",
            successCreateTxt: "ENREGISTRE AVEC SUCCES",
            seeNewCancelBtnText: "RETOUR A LA LISTE"
        },
        brandadmin: {
            name: "Nom",
            access: "Accès aux fonctionnalités",
            title: "Accès aux applications par marque"
        },
        menulayer: {
            title: "CALQUES"
        },
        abonnement: {
            title: "Abonnement",
            brand: "Marque",
            application: "Applications",
            nbUser: "Nombre d'utilisateur",
            nbModule: "Nombre de nouveau module créé depuis le",
            nbProduct: "Nombre de nouveau produit créé depuis le",
            nbShade: "Nombre de nouvelles teintes créées depuis le",
            diffusion: "Liste de diffusion",
            startSub: "Début",
            endSub: "Fin",
            maintainDiffusion: "Gérer la liste de diffusion",
            close: "Fermer",
            addUserToDiffusion: "Ajouter destinataire",
            previous: "Précédant",
            save: "Enregistrer"
        },
        versionPlano: {
            version: "Version",
            saveBy: "Sauvegardé par"
        },
        launchForecast: {
            xlsImport: {
                title: "Importazione file XLS",
                helpText: "Hai bisogno di aiuto? Consulta le nostre istruzioni",
                helpLink: "qui",
                browse: "SFOGLIA",
                upload: "CARICA",
                matchResult: "{matched} corrispondenza/e su {total} componente/i",
                clientSapRef: "Rif. cliente SAP",
                forecastAction: "Azione Forecast",
                currentPrice: "Prezzo attuale",
                priceToImport: "Prezzo da importare",
                priceAction: "Azione prezzo",
                forecastActionTooltip:
                    "- Il riferimento verrà aggiunto se non esiste nel FORECAST.<br>- Nessuna azione verrà eseguita se il riferimento esiste già nel Forecast.<br>- Nessun riferimento viene cancellato dal Forecast tramite l'importazione XLSX.",
                priceActionTooltip: "Vengono importati solo i prezzi per i riferimenti di tipo Z001.",
                toAdd: "Da aggiungere",
                toUpdate: "Da aggiornare",
                toRemove: "Da rimuovere",
                existingRef: "Rif. esistente",
                notImported: "Non aggiornato",
                notImportedType: "Non importato ({type})",
                unknownRefs: "I seguenti riferimenti non sono attualmente presenti in REM3RCH :",
                cancel: "ANNULLA",
                startImport: "AVVIA IMPORTAZIONE",
                uploadSuccess: "File XLS caricato con successo",
                importSuccess: "Importazione riuscita",
                errorImport: "ERRORE IMPORTAZIONE"
            }
        }
    },
    cn: {
        trad: "cn",
        headerAdmin: {
            list: "季度列表",
            cpnt_management: "新建模具",
            client: "client",
            admin: "管理",
            super_admin: "super admin",
            meuble: "MEUBLE参数",
            campaign: "新建季度",
            template: "选择柜台",
            displayers: "展示柜",
            uploadPage: "导入模具",
            zone: {
                add: "添加区域",
                create: "新建区域",
                displayDeletedZone: "Display deleted zones",
                client_ref: "client ref",
                name: "name",
                type: "type",
                group: "group",
                brands: "brands",
                users: "users",
                edit_type: "edit type",
                parameters: "parameters",
                deleted: "deleted"
            },
            design: "DESIGNS",
            brand: "品牌",
            zoneList: "区域",
            zone_group: {
                manage: "manage zone group"
            },
            componentList: "模具类型",
            user: "用户"
        },
        saved: "saved",
        template: {
            form: {
                loadingError: "Form is still loading",
                missingError: ":name is required but missing",
                name: "Name",
                ref: "Reference",
                zone: {
                    label: "Zone",
                    empty: "Please select a zone"
                },
                standDesign: {
                    label: "Stand Design",
                    empty: "Please select a stand design"
                },
                displayerType: {
                    label: "Displayer type",
                    empty: "Please select a displayer type"
                }
            }
        },
        systemTypes: {
            1: "tile",
            2: "shelf",
            3: "caddy",
            4: "new caddy"
        },
        error: {
            403: {
                error: "ERROR!",
                errorText: "ACCESS DENIED"
            },
            404: {
                error: "ERROR!",
                errorText: "PAGE NOT FOUND"
            }
        },
        actions: {
            confirm: "Confirm",
            search: "搜索",
            cancel: "Cancel",
            addUser: "Add a new user",
            remove: "Remove",
            edit: "edit",
            delete: "delete",
            history: "history"
        },
        changeAccess: {
            title: "update access",
            desactivate:
                "Are you sure you want to deactivate <b>{fullName}</b> from REM3RCH ? <br />" +
                "This user won't be able to access the site anymore, regardless of the brand.",
            activate:
                "Are you sure you want to re-activate <b>{fullName}</b> on REM3RCH ?  <br />" +
                "This user will have access to all the brands he previously had access to."
        },
        createUser: {
            title: "Add new user",
            msgSearch: "Enter his/her email address to check if this user already has an account in Rem3rch :",
            hasAccessBrand: "This user is already registered in Rem3rch with an access to {brand}",
            updateBrand: "This user is already registered in Rem3rch, but with access to another brands :",
            confimUpdateBrand: "Do you confirm a new access to the brand {brand} ?",
            InputEmpty: "This user is not currently in our database. Please fill in the following fields to complete the user creation.",
            labelMan: "Man",
            labelWoman: "Woman",
            labelGenre: "Genre",
            fieldsError: "Required fields",
            labelFirstName: "First name",
            labelLastName: "Last name",
            labelEmail: "E-mail",
            labelBrand: "Brand",
            searchIt: "Search it",
            backToUsersList: "Back to users list",
            yesIConfirm: "Yes I confirm",
            manageUserRights: "Manage user's rights"
        },
        deleteBrand: {
            message: "Are you sure you want to delete the brand {brand} from the user",
            messageAction: "This action cannot be undone.",
            msgDelete: "You must logout for deletion to take effect",
            confirmTitle: "ERROR",
            warningText: "Deletion is not allowed because it is being used as reference"
        },
        userList: {
            title: "Users",
            viewActiveOnly: "View only active users",
            activateAllBrands: "Activate all brands",
            brand: "Brand",
            email: "email",
            remerchAccess: "REMERCH access",
            lastConnection: "last connection",
            emptyList: "Empty list",
            search: "Search",
            edit: "edit",
            delete: "delete"
        },
        gui: {
            form: {
                error: {
                    mandatory: "This field is mandatory",
                    integer: "Value expected integer",
                    float: "Value expected float",
                    email: "Email is not validate",
                    mask: "The field is not validate "
                }
            }
        },
        cguModal: {
            title: "Terms and Conditions",
            acceptButton: "I read and accept the terms and conditions",
            refuseButton: "Refuse",
            acronyme: "T&C"
        },
        checkBoxModal: {
            selectAll: "Select all",
            selectNone: "Select None",
            copyButton: "Copy to all these zones"
        },
        StatStatus: {
            titleArchived: "Archived/UnArchive",
            titleChangeStatus: "Change Status",
            contentArchived: "Êtes vous sur de vouloir",
            contentStatus: "Êtes vous sur de changer le status",
            cancel: "Annuler",
            valider: "Valider",
            labelArchived: "Archive",
            labelDesarchived: "UnArchive"
        },
        userAccess: {
            title: "MANAGE USERS BRAND ACCESS",
            search: "Search",
            clear: "Clear",
            brandAccessed: "Acces to the following brands",
            addAccess: "Add to the current brand",
            close: "CLOSE",
            super: "THIS USER IS A SUPER ADMIN",
            alreadyAccess: "THIS USER HAS ALREADY ACCESS TO THE CURRENT BRAND",
            infoSavedBrand: "Don't forget to give access to the brand functionnalities",
            linkButton: "Manage User Brand",
            alertMessage: "Are you sure you want to delete the access to this brand ?"
        },
        countdown: {
            nextcntd: "Upcoming countdowns",
            accessdenied: "Access denied.",
            creatnewcntd: "Create new countdown",
            listcntd: "Show list",
            emptycntd: "Countdown list is empty",
            colname: "Name",
            colstartdate: "Start date",
            colenddate: "End date",
            colstanddesign: "Stand design",
            colbrand: "Brand",
            colcreateupdate: "Create/Update",
            adddesc: "Enter description",
            btncreate: "Create",
            btncancel: "Cancel",
            btndelete: "Delete",
            confirmdelete: "Please confirm, deleting countdown "
        },
        preferences: {
            title: "User preferences",
            label: {
                name: "Name",
                userName: "Firstname",
                password: "Password",
                language: "language (default)",
                brand: "Brand (default)",
                zoned: "zone (default)",
                stands: "Stand design (default)",
                campaign: "Campaign (default)"
            },
            option: {
                language: "Last value",
                brand: "Last value",
                zoned: "Last value",
                stands: "Last value",
                campaign: "Last value"
            },
            message: {
                valider: "Save Preferences"
            },
            btn: {
                label: "Save Preferences"
            },
            terms: "You accepted terms of services on 05/04/2018.  Read terms of services",
            subscription: "Subscription to Rem3rch : Read subscription details",
            successMessage: "Preferences Saved"
        },
        shelfEditor: {
            componentTypeLabel: "Component type"
        },
        plano: {
            editor: {
                header: {
                    file: {
                        label: "文件",
                        save: "保存",
                        saveAs: "另存为",
                        renamePlanogram: {
                            labelMenu: "重命名",
                            labelRenamePlano: "重命名",
                            close: "取消",
                            valider: "确认"
                        },
                        saveAndExit: "保存并退出",
                        exit: "退出"
                    },
                    export: {
                        label: "导出",
                        print: "打印",
                        exportHdPdf: "导出 HD PDF",
                        exportLdPdf: "导出 LD PDF",
                        exportExcel: "导出 Excel"
                    },
                    window: {
                        label: "窗口",
                        toolbar: "工具栏",
                        library: "库",
                        layers: "层",
                        newbieToolbar: "新手栏"
                    },
                    help: {
                        label: "帮助",
                        shortcutList: {
                            label: "捷径",

                            "zoom+": "缩放 +",
                            "zoom-": "缩放 -",
                            copy: "复制",
                            paste: "粘贴",
                            save: "保存",
                            undo: "撤销",
                            redo: "重做",
                            delete: "删除",
                            edit: "编辑",
                            addToFavorites: "添加至收藏",
                            group: "组合",
                            ungroup: "取消组合",
                            print: "打印",
                            magnet: "切换磁铁",
                            toggleLayers: "切换图层",
                            toggleLibrary: "切换"
                        },
                        fileInfo: "文件信息",
                        help: "帮助"
                    }
                },
                corruptedModulesModal: {
                    title: "这些模块缺少图像",
                    missingModuleMessage: "component unavailable for this planogram",
                    subTitle: "Please contact the Rem3rch team for more information."
                }
            },
            lock: "已锁",
            noresult: "对不起，没有搜索结果",
            gotocatalogue: "翻过目录",
            search_planogram: "搜索货架",
            create: "+ 创建货架",
            select_campaign_label: "Campaign",
            select_campaign_ele: "ALL CAMPAIGNS",
            select_zone_label: "区域",
            select_zone_ele: "---",
            select_height_label: "高",
            select_height_ele: "---",
            select_width_label: "宽",
            select_width_ele: "---",
            select_brand_label: "客户",
            select_brand_ele: "---",
            select_stand_type_label: "Displayer 类型",
            select_stand_design_label: "Stand Design",
            select_sortBy_label: "排序方式",
            select_sortBy_ele: "创建日期",
            duplicate_plano: "复制货架",
            enter_new_name: "给货架命名",
            select_campaign: "选择一个 campaign",
            select_zone: "选择一个区域",
            btn_validate: "确认",
            name_placeholder: "你的货架的名字",
            your_plano: "你的货架",
            duplicate_message: "复制后被命名于",
            open_plano: "打开货架",
            note_duplicate_plano: "请注意: 根据你新的货架,确认并更换你的campaign/区域",
            confirmExit: {
                title: "您想要保存货架更改吗 : {name} ?",
                message: "(如果不保存，您将丢失你的更改)",
                dontSaveButton: "不保存",
                saveButton: "保存",
                cancelButton: "取消"
            },
            saveAsModal: {
                saveAsLabel: "另存为"
            },
            infoModal: {
                title: "信息",
                name: "名字",
                zone: "区域",
                designAndCampaign: "design / campaign",
                design: "design",
                size: "尺寸",
                type: "类型",
                createdOn: "创建于",
                modifiedOn: "最后更改于"
            },
            caddy: {
                editor: {
                    frames: {
                        title: "框架"
                    },
                    tickets: {
                        title: "票"
                    },
                    fascias: {
                        title: "fascias",
                        create: "create a new fascia"
                    }
                }
            }
        },
        common: {
            open: "打开",
            cancel: "奇效",
            close: "关闭",
            finish: "关闭",
            footerDate: "© REM3RCH-2020",
            deconnexion: "登出",
            profil: "我的信息",
            preferences: "收藏",
            edit: "更新",
            pdf: "下载 PDF",
            download: "download",
            upload: "upload",
            error: "Oooops, something went wrong. Sorry for the inconvenience.",
            exportPDF: "Export PDF",
            search: "搜索",
            delete: "删除",
            disable: "disable",
            remove: "remove",
            history: "history",
            ok: "OK",
            save: "保存",
            reset: "重启",
            versioning: "Versioning",
            create: "新建",
            createBasket: "新建购物篮",
            ref: "编号",
            required: "需要",
            campaign: "Campaign",
            ref: "编号",
            by: "被",
            searchAll: "搜索所有模具",
            planogram: "Planogram",
            catalog: "Catalog",
            dateTimeFormat: "YYYY-MM-DD [at] HH:mm",
            yes: "yes",
            no: "no"
        },
        formErrorMessages: {
            emptyField: "This field is required",
            mailInvalid: "Please enter a valid email address",
            fieldTooLong: "Field too long",
            color: "Please fill this field with a valid color format (ex: blue, rgb(0,0,255) or #0000FF)"
        },
        menuCatalogStar: {
            linkViewFeattured: "查看精选",
            linkViewAll: "查看所有"
        },
        dashboardModule: {
            catalogTitle: "目录",
            planoTitle: "货架",
            catSubTitle: "最新修改",
            featureTitle: "个人收藏",
            myOrdersTitle: "我的订单",
            planoSubTitle: "最新改动",
            newItem: "创建新物品",
            seeAllCat: "进入目录",
            seeAllPlanos: "查看所有货架",
            seeAllOrders: "查看所有订单",
            open: "打开",
            option: "选项",
            changeBrand: "更改品牌",
            changeZone: "更改区域",
            changeCampaign: "更改季度",
            allCampaign: "所有季度",
            allCampaignShort: "所有季度",
            information: "信息",
            info: "信息",
            thOrderID: "订单编号",
            thBuyer: "购买者",
            thLastActivity: "更改日期",
            thStatus: "订单状态"
        },
        menuHeader: {
            homeLink: "首页",
            catalogueLink: "目录",
            planoLink: "搭建货架",
            planosLink: "货架",
            forecastLink: "Launch Forecast",
            catalogForecastLink: "Catalog Forecast",
            tools: {
                name: "tools",
                manageUsers: "manage users",
                manageZones: "manage zones",
                manageCampaigns: "manage campaigns",
                exportExcel: "archive export"
            },
            menu: "菜单",
            selectBrand: "选择一个菜单",
            selectZone: "选择一个区域",
            selectCampaign: "选择一个季度",
            help: "Help"
        },
        help: {
            title: "Help",
            catalog: "catalog",
            launch_forecast: "launch forecast",
            catalog_forecast: "catalog forecast",
            tools: "tools",
            uploadPdf: "Upload<br>PDF",
            uploadPdfError: "Upload PDF error",
            noFile: "No file"
        },
        shades: {
            title: "色彩",
            allActive: "现区域可用的色彩",
            zoneShades: "现区域所有的色彩",
            allShades: "所有区域所有的色彩",
            add: "添加色彩",
            noShades: "对不起，无可用色彩",
            import: "导入色彩",
            label: "色彩",
            certified: "认证色彩",
            color: "颜色",
            campaignL: "发布季度",
            msgResultSearch: "您的搜索返回了 <span>{result}</span> 结果",
            afterDelete: "这个颜色未在其他货架使用",
            confirmDelete: "确认删除",
            deleteWarning: "这个颜色在以下货架中被使用:",
            btndelete: "删除",
            form: {
                name: "Please entre the name",
                ref1: "Please enter the client ref1"
            }
        },
        product: {
            back: "返回搜索结果",
            notPublished: "[未发布]",
            articleInfos: "物品信息",
            zoneCampaignInfos: "Zone and Campaign Information",
            description: "描述",
            price: "* Recommended retail price",
            relatedProduct: "related products",
            productsModule: "product used on the following modules",
            manage: "Manage association",
            launch: "发布",
            discontinued: "中断",
            noComponent: "这个模具不适用于您选择的季度/区域",
            publish: "发布",
            ticket: "Manage ticket strips",
            errorCompagn: "请选择一个季度",
            labelLancement: "Launch date",
            labelDiscontinuer: "Discontinuation date",
            labelSelectZone: "Select zone",
            labelCertif: "Certified shade",
            deleteModal: {
                confirmTitle: "Delete this component ?",
                warningText: "Are you sure? You won't be able to revert this!",
                confirmDelete: "Yes, delete it!"
            }
        },
        contentPage: {
            backToSearch: "返回",
            btnEdit: "更新"
        },
        modulePage: {
            infosArticle: "物品详情",
            description: "描述",
            productsModule: "模具上的产品",
            moduleProduct: "产品上的模具",
            ticketStrips: "票条",
            allTickets: "查看所有票条"
        },
        catalogue: {
            clear: "重置过滤器",
            weFound: "Your search",
            results: "Results",
            for: "for",
            return: "returned",
            tri: "Sort",
            filter: "Filters",
            allCampaign: "All campaigns",
            exportpdf: "ADD INTO EXPORT PDF",
            basket: "ADD TO BASKET",
            allZonesAbr: "all",
            allZonesDesc: "",
            allZonesName: "All zones",
            comment: "Comment",
            status: "状态",
            none: "无",
            updateStatusButton: "Update status",
            updateStatusSuccess: "Status Updated",
            systemType: "系统类型",
            filters: {
                component: "Components",
                standDesign: "Stand Design",
                status: "Status",
                systemType: "System",
                starred: "Starred",
                published: "Published",
                categories: "Categories",
                sections: "Sections"
            }
        },
        login: {
            forgot: "Forgot your password ?"
        },
        change: {
            selectBrand: "Select Brand"
        },
        meublePlano: {
            save: "Save",
            numberOfBlocs: "Number of divider",
            blocWidth: "Blocs width",
            setBloc: "Set blocs",
            stripSize: "Strip size",
            segmentation: "Segmentation",
            name: "Name",
            title: "Configuration planogram display",
            externalSize: "External sizes",
            internalSize: "Interal sizes",
            width: "Width",
            height: "Height",
            header: "Header",
            footer: "Footer",
            planoModule: "Inner shopping size",
            pitchH: "Horizontal pitch",
            pitchR: "Number of repetitions",
            pitchV: "Vertical pitch",
            remainingSpaceH: "Horizontal remaining space",
            remainingSpaceV: "Vertical remaining space",
            error: "The combinaison pitch x repetitions excess the size of the display",
            errorSetStandDesign: "You need to specify a stand design"
        },
        templatePlano: {
            type: "Type",
            size: "Size",
            template: "Template",
            summary: "Summary",
            createTitle: "Create a planogram",
            planoName: "Enter a title to your planogram",
            campaign: "Select a campaign",
            sizeTitle: "Select a planogram size",
            templateTitle: "Select a planogram template",
            planoName: "Planogram name",
            campaignS: "Campaign",
            zone: "Zone",
            standDesign: "Stand Design",
            zoneTitle: "Select a zone",
            brand: "Brand",
            brandTitle: "Select a brand",
            planoSize: "Planogram size",
            planoTemp: "Planogram template",
            send: "Save",
            nextStep: "Next step",
            previousStep: "Previous Step",
            title: "Planogramme name",
            width: "Width",
            widthTitle: "Select a width",
            height: "Height",
            heightTitle: "Select a height"
        },
        planoSelect: {
            edit: "Edit",
            duplicate: "Duplicate",
            move: "Move",
            addToFavorite: "Add to favorite",
            addToScratchpad: "Add to scratchpad",
            group: "Group",
            deleteModule: "Delete",
            ungroup: "Ungroup",
            ungroupall: "Ungroup all",
            addComment: "Add a comment"
        },
        favorite: {
            title: "Save as favorite",
            name: "Please name this favorite",
            save: "save",
            noFavorite: "No favorite"
        },
        commentPanel: {
            title: "Notes / Comments",
            personalNoteTitle: "Personal Note",
            removePersonalNote: "remove",
            send: "Send comment",
            addComment: "Add Comment",
            addPersonalNote: "Save as a Personal Note",
            allComments: "View all comments",
            reply: "Replies",
            asOpened: "Tag as opened",
            asClosed: "Tag as closed",
            includePdf: "Include comments in PDf",
            excludePdf: "Remove comments from PDf",
            confirmDelete: "Are you sure to delete this Personal Note ?",
            deleteAction: "Delete",
            updateCommentMessage: "Comment updated succesfully",
            updateCommentErrorMessage: "An error occurred while updating this comment",
            newCommentMessage: "New comment added succesfully",
            newCommentErrorMessage: "An error occurred while saving your comment",
            deletePersonalNoteSuccessMessage: "Personal note removed",
            deleteCommentErrorMessage: "An error occurred while removing your personal note",
            replySubCommentPh: "Your reply",
            newCommentPh: "Your note / comment",
            replyButton: "Reply"
        },
        comments: {
            send: "Send Comment"
        },
        headerPlano: {
            cancel: "取消",
            saveExit: "保存并退出",
            save: "保存",
            back: "返回"
        },
        planoList: {
            planogram: "货架",
            lock: "正在编辑中",
            created: "创建于",
            modified: "修改于",
            by: "Par",
            visibility: "可见",
            comments: "评论",
            option: " 选项 ",
            duplicate: "复制",
            delete: "删除",
            submitted: "已提交",
            in_progress: "正在进行",
            approved: "批准",
            history: "最新版本",
            editName: "编辑名字",
            order: {
                level: "Niveau",
                cd_asc: "Date de création CROISSANT",
                cd_desc: "Date de création DECROISSANT",
                md_asc: "Date de modification CROISSANT",
                md_desc: "Date de modification DECROISSANT",
                camp_asc: "Date de campagne CROISSANT",
                camp_desc: "Date de campagne DECROISSANT",
                h_asc: "Hauteur CROISSANT",
                h_desc: "Hauteur DECROISSANT",
                w_asc: "Largeur CROISSANT",
                w_desc: "Largeur DECROISSANT"
            }
        },
        planobuilder: {
            export: "export",
            support: "support",
            comment: "comments",
            favorite: "favorites",
            scratch: "scratchpad",
            library: "library",
            shades: "shades",
            ticketStrip: "Ticket strip",
            saveShades: "save",
            cancelShades: "Cancel",
            view: "Render",
            hide: "Hide",
            by: "创建人",
            modifiedBy: "修改人",
            on: "于",
            blackwhite: "Black & White",
            iconscolors: "Icons colors",
            shadesRef: "Shades",
            realistic: "Realistic",
            frameHide: "Accessories",
            highlights: "Highlights",
            messageAlert: "In order to display the planogram in a different language, the planogram will be saved.",
            messageAlert1: "This ticket strip is not related to this module.",
            messageAlert2: "You can't put this module here because this location is not available",
            messageAlert3: "The module can not be out of the plano",
            warning: "Warning",
            layer: "Layers",
            modules: "Modules",
            reference: "Reference",
            selection: "Selection",
            pan: "Pan",
            ungroupall: "Ungroup all",
            posInit: "Position initial",
            zoomModule: "Zoom Module",
            zoomIn: "Zoom in",
            zoomOut: "Zoom out",
            exportPreview: "Export PDF with page setup",
            exportPDF: "Direct Export PDF",
            exportXLS: "Export XLS",
            highDefinition: "High Definition",
            lowDefinition: "Low Definition",
            popinModuleErrorTitle: "Warning, following modules are not available for this zone and this campain:",
            highlightsShade: {
                menu: {
                    blue: "Blue",
                    red: "Red",
                    yellow: "Yellow",
                    green: "Green",
                    violet: "Violet",
                    none: "None"
                }
            }
        },
        crudComponent: {
            name: "名字",
            uses: "使用类型",
            nameEnRequired: "Cpnt name (en) is required",
            nameFrRequired: "Cpnt name (fr) is required",
            nickname: "货架中命名",
            nicknameEnRequired: "Cpnt Plano module name (en) is required",
            nicknameFrRequired: "Cpnt Plano module name (fr) is required",
            description: "描述",
            descriptionEnRequired: "Cpnt description (en) is required",
            descriptionFrRequired: "Cpnt description (fr) is required",
            type: "模具类型 PLano",
            chooseBrand: "Active brand",
            chooseCategory: "选择类别 / 子类别",
            chooseStatus: "选择状态",
            selectCategory: "选择类别",
            selectStatus: "选择状态",
            categoryRequired: "Categories must be selected",
            addCategory: "添加类别",
            removeCategory: "移除类别",
            choosedefaultCampaign: "选择默认季度",
            launchDate: "发布季度",
            standDesign: "Stand Design",
            discontinued: "Discontinued campaign",
            selectCampaign: "Select campaign",
            addProperties: "Add properties",
            title: "新建模具",
            selectSubCat: "选择一个子目录",
            eStoreTypeTitle: "Available for e-Store",
            chooseSystemType: "选择一个系统类型",
            applyPrices: "适用于所有区域"
        },
        eStoreType: {
            nobody: "不可用",
            everybody: "所有人",
            diam: "仅Diam用户 "
        },
        displayer: {
            create: "create a new display configuration",
            filters: "过滤",
            delete: "删除",
            edit: "编辑"
        },
        imgEditor: {
            delete: "删除",
            addPicture: "添加/修改图片",
            close: "关闭",
            save: "保存",
            infoDrag: "您可以通过拖拽重新排列图片的顺序",
            labelImg: "上传新图片",
            labelSelect: "选择图片类型",
            invalidFormat: "不支持的图片格式：请上传 png、jpg 或 svg 文件。",
            noImage: "请先上传图片再保存。"
        },
        modalComment: {
            noComment: "No comment recorded on this planogram"
        },
        related: {
            showOnly: "Show only Modules on same Catagory/ Sub-category",
            search: "Search"
        },
        scratchPad: {
            noScratch: "No item added to scratchpad"
        },
        exportPdfPlano: {
            iconLayout: "Icon layout",
            page: "Page",
            export: "Export PDF",
            close: "Close",
            exportXls: "Export XLS"
        },
        duplicatePlano: {
            saveName: "This name already exists",
            enterName: "Please enter a plano name",
            selectCampaign: "Please select a campaign",
            selectZone: "Please select a zone"
        },
        component: {
            configurator: "模具编辑器",
            imgEditor: "图片编辑器",
            notPublished: "未发布",
            categories: "类别",
            subCat: "子类别",
            nickname: "Nickname",
            nameEn: "EN 名字",
            nameFr: "FR 名字",
            typeComponentForPlano: "Plano type",
            moduleConfifured: "Module configured on {date} by {user}",
            moduleLastModified: "Configuration last modified on {date} by {user}",
            savePrices: "保存图片",
            cancel: "取消"
        },
        campaign: {
            create: "Create a campaign",
            brand: "Select a brand",
            standDesign: "Stand design",
            selectStandDesign: "Select a stand design",
            startCampaign: "Campaign launch",
            endCampaign: "Campaign end",
            createBtn: "Save",
            campaignName: "Enter a campaign Name",
            shortName: "Enter a short name"
        },
        configurator: {
            confirmGroup: "Confirm group",
            save: "Save",
            saveClose: "Save and exit",
            warning: "Warning",
            messageAlert1: "Selection a tester",
            messageAlert2: "The path is not include into the group",
            messageAlert3: "The color configuration of this module will be reset for all planograms.",
            messageAlert4: "Warning: He make to select a product.",
            messageAlert5: "Warning: He make to select a ticket strip",
            close: "Close",
            cleanConf: "Clean configuration",
            product: "Product",
            ticket: "Ticket strip"
        },
        modalNavigatorIncompatible: {
            warningText:
                "Sorry, this application is, at the moment, only available on Chrome.\n" +
                "New browsers will be supported very soon. \n" +
                "Thank you for your patience.",
            confirmButtonText: "OK"
        },
        modalComponentCreate: {
            errorCreateTxt: "ERROR IN OBJECT RECORDING",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREATE A NEW COMPONENT",
            successCreateTxt: "SUCCESSFULLY CREATED",
            seeNewCancelBtnText: "SEE THE ELEMENT CREATED",
            noBasketSelected: "PLEASE CHOOSE A BASKET",
            addItemBasketError: "AN ERROR OCCURRED WHILE ADDING THIS ITEM IN THE CURRENT BASKET."
        },
        modalImportFile: {
            errorImportTxt: "IMPORT FAILED",
            errorImportCancelBtnTxt: "TRY AGAIN",
            errorImportConfirmBtnTxt: "SEE FILE ERROR LOG",
            successImportTxt: "IMPORT SUCCESS <br/>" + "{count} {componentType} imported",
            successImportConfirmBtnTxt: "OK"
        },
        wishlist: {
            title: "ADD TO MY LIST",
            title3: "MY LIST",
            title2: "Choose a list in which you want to save the article:",
            btadd: "Add into a new list",
            btnexport: "Export",
            deleteList: "Delete",
            addtolistsuccess: "Component {name} added to the list",
            messageAlertDelete: "Are you sure to delete the list",
            btYes: "Yes",
            btNo: "No"
        },
        addlist: {
            add: "Create list",
            label: "Name"
        },
        import: {
            action: "Import",
            type: "Type",
            choose: "选择一个类型",
            module: "Module",
            product: "Product",
            accessory: "Accessory",
            modules: "modules",
            products: "products",
            accessories: "accessories"
        },
        campaignCreate: {
            errorCreateTxt: "ERROR IN OBJECT RECORDING",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREATE A NEW CAMPAIGN",
            successCreateTxt: "SUCCESSFULLY CREATED",
            seeNewCancelBtnText: "GO BACK TO THE LIST"
        },
        editCampaign: {
            name: "NAME",
            shortName: "SHORTNAME",
            launch: "LAUNCH DATE",
            lastCampaign: "LAST CAMPAIGN",
            end: "END DATE",
            save: "SAVE",
            delete: "DELETE",
            edit: "EDIT",
            stand: "STAND DESIGN",
            warningText: "This campaign cannot be deleted because it's being used by some components/planograms"
        },
        standDesign: {
            edit: "Edit a design",
            name: "name",
            description: "description",
            save: "save",
            delete: "delete",
            create: "Create a design",
            type: "Type",
            chooseType: "Select a type design"
        },
        campaignList: {
            createdBy: "Created by",
            createdOn: "on",
            modifiedBy: "Modified by",
            modifiedOn: "on"
        },
        sandbox: {
            message: "Warning : This is a test site - Data stored on this site can be re-initiliazed at any time"
        },
        userrole: {
            rights: "rights",
            none: "none",
            notfound: "No user",
            superadmin: "Super administrator",
            copyToAnotherZone: "Copy to another zone",
            filterProfile: "FILTER BY PROFILE",
            filterGroup: "FILTER BY GROUP",
            selectProfile: "SELECT PROFILE",
            viewZone: "VIEW ZONE",
            isClientAdmin: "Client admin ?",
            isSuperAdmin: "Super admin ?",
            deleteFromBrand: "Are you sure you want to delete the user <b>{user}</b> from the brand <b>{brand}</b> ?",
            messageAccessBrand: "This user has access to these others brands. Click on a brand to manage this user's rights.",
            noRight: "You don't have enough right to modify this attribute."
        },
        zonerole: {
            rights: "rights",
            ref: "ref",
            type: "type",
            group: "group",
            notfound: "No zone",
            filterProfile: "FILTER BY PROFILE",
            selectProfile: "SELECT PROFILE",
            viewUser: "VIEW USER",
            disable_zone: "DISABLE ZONE",
            deleteFromBrand: "Are you sure you want to delete the zone <b>{zone}</b> from the brand <b>{brand}</b> ?",
            deleteZone: "Are you sure you want to deactivate <b>{zone}</b> from REM3RCH ?",
            messageAccessBrand: "This zone has access to these others brands. Click on a brand to manage this zone's rights."
        },
        userAdmin: {
            manage: "manage",
            access: "access",
            reset_password: "reset password",
            edit_info: "modify info",
            delete_from_brand: "delete from brand",
            disable_user: "deactivate all access",
            enable_user: "reactive all access"
        },
        zoneGroups: {
            title: "Manage zone group",
            zonesForRight: "Zones for right management",
            zonesForDashboard: "Zones to display on dashboard",
            add: "Add new group",
            deleteGroup: "Delete group",
            availableZones: "Available Zones",
            zonesToBelong: "Zones belonging to the group",
            deleteFromBrand: "Are you sure you want to delete the group <b>{group}</b> from the brand <b>{brand}</b> ?",
            copyTo: "Copy to"
        },
        brand: {
            create: "CREATE A NEW BRAND",
            createTitle: "Create a brand",
            seeNewConfirmBtnText: "CREATE A NEW BRAND",
            successCreateTxt: "SUCCESSFULLY CREATED",
            successUpdateTxt: "SUCCESSFULLY UPDATED",
            seeNewCancelBtnText: "GO BACK TO THE LIST",
            example: "EXAMPLE: RGB(XXX,XXX,XXX) OR #727A96",
            name: "Name",
            linkColor: "Link",
            fourthColor: "Tag lines",
            backgroundColor: "Background",
            rem3rchLogo: "Div Background",
            brandTheme: "Theme",
            brandHiddenPrice: "Show prices in e-store for clients",
            brandHiddenNo: "No",
            brandHiddenYes: "Yes",
            nameRequired: "Please enter a name",
            logoRequired: "Please upload a logo",
            colorTitle: "Colours",
            colorFormatInfo: "Accepted formats : Name (blue), rgb(0,0,255), Hex (#0000FF)",
            removeImgButton: "Remove",
            confirmRemoveHeroImg: "Are you sure you want to remove the homepage hero image ?",
            confirmRemoveLogo: "Are you sure you want to remove the logo ?",
            removeImgSuccess: "Image removed successfully",
            currency: "currency",
            errorCurrency: "Please select the currency",
            code: "Code",
            colorsError: "One or more colors are missing. Please fill all colors field."
        },
        zone: {
            create: "Create a zone",
            createNew: "Create new zone",
            brandInactive: "This brand has been removed from the zone",
            relationBetween: "Relation between {zone} and {brand} :",
            allowCatalogForecast: "Allow catalog forecast",
            allowCatalogFirmOrder: "Allow firm order",
            name: "Name",
            abbreviation: "Abbreviation",
            refClient: "Client Reference",
            description: "Description",
            save: "save",
            addZone: "Add zone",
            delete: "delete",
            errorCreateTxt: "ERROR IN OBJECT RECORDING",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREATE A NEW ZONE",
            successCreateTxt: "SUCCESSFULLY CREATED",
            seeNewCancelBtnText: "GO BACK TO THE LIST",
            noSectionSelected: "YOU NEED TO SELECT A SECTION",
            brand: "Brand",
            nameRequired: "Please enter a name",
            abbrRequired: "Please enter an abbreviation",
            sectionRequired: "Please select a section",
            copy: "Copy components from the zone/campaign",
            allZone: "All zones",
            selectZone: "Please select a zone",
            selectCampaign: "Please select a campaign",
            selectNewCampaign: "Please select a new campaign",
            copyFromZone: "Copy from Zone",
            campaignNeeded: "A campaign is required when 'All Zones' is selected.",
            newCampaignNeeded: "The new campaign is required when a reference campaign is selected.",
            copyFromZoneDesc: "Selecting a Zone only : The new zone will be created as a copy of the selected zone",
            copyFromZoneCampaign: "Copy from Zone & Campaign",
            copyFromZoneCampaignDesc:
                "Selecting a Zone and a Campaign : The new zone will be created a copy of the selected zone, all active componants will have a Launch campaign = selected Campaign",
            campaign: "Campaign",
            newCampaign: "New Campaign",
            cannot_find: "Cannot find the zone you looking for ?",
            select_zones: "Select a zone",
            section: "Section",
            createSearchMessage: "Enter a keyword (country name for example) or its code to check if this zone already exists in Rem3rch :",
            backToZoneList: "Back to zone list",
            selectIt: "Select it",
            editWarning: "Please note that changes will only take effect at the start of the next period."
        },
        launchForecast: {
            xlsImport: {
                title: "导入XLS文件",
                helpText: "需要帮助？请查看我们的说明",
                helpLink: "这里",
                browse: "浏览",
                upload: "上传",
                matchResult: "{total}个组件中匹配到{matched}个",
                clientSapRef: "客户SAP编号",
                forecastAction: "预测操作",
                currentPrice: "当前价格",
                priceToImport: "待导入价格",
                priceAction: "价格操作",
                forecastActionTooltip:
                    "- 如果参考不存在于FORECAST中，将被添加。<br>- 如果参考已存在于Forecast中，则不执行任何操作。<br>- XLSX导入不会删除Forecast中的参考。",
                priceActionTooltip: "仅导入Z001类型参考的价格。",
                toAdd: "待添加",
                toUpdate: "待更新",
                toRemove: "待删除",
                existingRef: "已存在的参考",
                notImported: "未更新",
                notImportedType: "未导入 ({type})",
                unknownRefs: "以下参考目前不在REM3RCH中：",
                cancel: "取消",
                startImport: "开始导入",
                uploadSuccess: "XLS文件上传成功",
                importSuccess: "导入成功",
                errorImport: "导入错误"
            }
        },
        catalogForecast: {
            title: "catalog forecast",
            noPeriod: "No period",
            globalProgression: "global progression",
            periodOpening: "Period opening",
            forecastExported: "Forecast exported",
            firmOrderClosing: "Firm order closing",
            rechallenge: "rechallenge",
            rechallengeMarkets: "rechallenge markets",
            rechallengeMarketsModal: {
                title: "Rechallenge Markets",
                message: "Select the markets you would like to (re)submit forecasts",
                messageLabel: "Message"
            },
            market: {
                rechallenged: "Re-challenged :<br>click here to see the message :",
                saveAndSubmit: "Save and submit",
                searchItem: "Search an item",
                searchByCategory: "Search by category",
                selectCategory: "Select category",
                wasRechallenged: "was rechallenged",
                rechallengedByOn: "by {user} on {monthText} the {dayth}",
                messageLabel: "Message",
                accessMessage: "You'll be able to access the message again you're on the next page",
                nameLabel: "Name",
                unitLabel: "Unit per box",
                quotaLabel: "Quota",
                labOfficeLabel: "Lab Office",
                parentCodeLabel: "Parent code",
                switchToCatalogDateLabel: "Switch to catalog date",
                productHierarchyLabel: "Product Hierarchy",
                typeLabel: "Type",
                statusLabel: "Status",
                warningDownload: "The template has already been downloaded :",
                warningDownload2: "Are you sure you want to download it ?",
                wrongFile: "Wrong file",
                wrongFileUploaded:
                    "Wrong template : This file was downloaded from another period or for another market.<br><br>Download the template dedicated to this table, then upload it again.",
                corruptedFileUploaded: "Error : File corrupted (columns or rows modified)",
                warningUpload: "The template has already been uploaded :",
                warningUpload2: "Are you sure you want to upload it ?",
                warningUpload3: "WARNING: you will overwrite quantities already filled by another user.",
                backToDashboard: "Back to dashboard",
                reference: "reference",
                references: "references",
                noPeriod: "No period available for this market",
                noItem: "No item",
                uploadSuccess: "<b>XLS uploaded !</b><br>Quantities saved automatically",
                warningSave:
                    "You have not saved your latest changes.<br>If you leave this page without saving, you will lose the latest changes.<br><br>Do you want to quit without saving?",
                warningSaveBeforeUpload:
                    "You have not saved your latest changes.<br>Uploading a file will overwrite quantities already filled.<br><br>Do you want to continue?"
            }
        },
        brandCreate: {
            errorCreateTxt: "ERROR IN OBJECT RECORDING",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "Logout",
            successCreateTxt: "SUCCESSFULLY CREATED",
            seeNewCancelBtnText: "GO BACK TO THE LIST",
            msglogout: "You must logout to access the new brand"
        },
        versioning: {
            title: "Versioning",
            save: "Save",
            add: "Add",
            id: "id",
            version: "Version",
            name: "Name",
            date: "Date",
            description: "Description",
            action: "Action",
            edit: "Edit",
            remove: "Delete",
            messageDelete: "Warning: Are you sure? You won't be able to revert this!",
            upcoming: "Upcoming",
            createBy: "Create by"
        },
        componentType: {
            create: "CREATE A COMPONENT TYPE",
            errorCreateTxt: "ERROR IN OBJECT RECORDING",
            errorCreateBtnTxt: "OK",
            errorCancelBtnText: "CANCEL",
            seeNewConfirmBtnText: "CREATE A NEW COMPONENT TYPE",
            successCreateTxt: "SUCCESSFULLY CREATED",
            seeNewCancelBtnText: "GO BACK TO THE LIST"
        },
        brandadmin: {
            name: "Name",
            access: "Access to applications",
            title: "Access to applications by brand"
        },
        menulayer: {
            title: "LAYERS"
        },
        abonnement: {
            title: "Subscription",
            brand: "Brand",
            application: "Applications",
            nbUser: "Number of users",
            nbModule: "Number of modules created since",
            nbProduct: "Number of products created since",
            nbShade: "Number of shades created since",
            diffusion: "Distribution list",
            startSub: "Start of subscription",
            endSub: "End of subscription",
            maintainDiffusion: "Manage the distribution list",
            close: "Close",
            addUserToDiffusion: "Add to diffusion list",
            previous: "Back",
            save: "save"
        },
        basket: {
            addBasketToPlano: "把货架放入购物车",
            shippingPrice: "{price}起 + 运费",
            deliveryDetails: "ADD TO BASKET",
            perPlano: "PER PLANOGRAM",
            units: "UNITS",
            add: "ADD TO BASKET",
            info: "This item will be added to the following basket",
            titleDetails: "Your basket",
            labelPrice: "Unit price",
            labelQuantity: "Quantity",
            labelUnit: "Unit",
            items: "items",
            removeLink: "Remove from basket",
            statusBasket: "{status} basket",
            userBasket: "Added to basket by",
            dateBasket: "on {date}",
            subTotal: "Sub total",
            noteBasket: "This price includes the cost of the parts without any shipping, discounts, or other costs",
            alertRemove: "Are you sure you would like to delete the item {item} from your basket ?",
            warning: "Warning",
            back: "返回购物篮",
            btnOrder: "Place order",
            placeOrderError: "An error has occurred while placing your order. Please try again at a later time."
        },
        messageError: {
            addName: "Please enter a basket name",
            addQuantityMultiple: "The minimum value is 1",
            select: "Please select a basket",
            reactiv: "Are you sure you want to reactivate this components ?",
            shades: "Are you sure you want to reactivate this shades ?",
            planos: "Are you sure you want to reactivate this planos ?"
        },
        eStore: {
            title: "ORDER LIST",
            name: "Name",
            brand: "Brand",
            zone: "Zone",
            status: "Status",
            last: "Last modify",
            details: "Details"
        },
        versionPlano: {
            version: "Version",
            saveBy: "Saved by"
        },
        basketMenu: {
            menuTitle: "购物篮",
            viewBasket: "View basket",
            viewAllBaskets: "View all baskets",
            noBasket: "You have no basket",
            warning: "Warning",
            deleteConfirmation: "Are you sure you would like to delete the basket {basket} ? ",
            deleteAction: "Delete",
            cancelAction: "Cancel"
        },
        displayerSystemType: {
            displayerTitle: "Displayers",
            selectSystemType: "Please select a system type"
        },
        orders: {
            historyAction: {
                delivery_address_added: "Delivery address added",
                purchase_order_added: "Purchase order added",
                delivery_address_updated: "Delivery address updated",
                purchase_order_updated: "Purchase order updated",
                shipping_method_cost_updated: "Shipping method cost updated"
            },
            title: "Order",
            deleteOrder: {
                textCancelOrder: "Are you sure you want to cancel your order ? this action cannot be undone.",
                confirmDelete: "Your order has successfully been deleted",
                hasDeleted: "This order has been deleted",
                btnListOrder: "Go to order list"
            },
            btnOrders: {
                btnPrint: "print order",
                btnCancel: "Cancel order",
                btnArchive: "Archive order",
                btnModify: "Modify"
            },
            labelStatus: "Current status",
            labelCreated: "Created on",
            labelCreatedBy: "by",
            labelLastUpdate: "Last modification",
            labelLastUpdateBy: "by",
            tableOrder: {
                element: "Element ID",
                description: "description",
                quantity: "QTY",
                plano: "Plano",
                unitPrice: "Unit price",
                totalPrice: "Total price",
                labelSubTotal: "Sub-total",
                labelShippingCost: "Shipping cost",
                labelShippingMethod: "Shipping method",
                labelShippingReference: "Shipping reference",
                labelShippingComments: "Comments",
                items: "Items",
                addShippingInfo: "Add",
                shippingInfoSuccess: "Shipping informations added.",
                errorShippingCost: "Invalid shipping costs . Please update the value of this field.",
                errorShippingMethod: "Select a shipping method.",
                validateTotalCostButton: "Validate Total Cost",
                validateTotalCostSuccess: "Total cost validated",
                errorDeliveryAddress: "Enter your delivery address"
            },
            timeline: {
                title: "Timeline"
            },
            message: {
                textMessage: "Send a message to diam + the order group",
                btnSen: "Send",
                history: "Order history"
            },
            labelPurchase: "Purchase order ref",
            timeAgo: {
                year: "{time} year(s) ago",
                month: "{time} month(s) ago",
                day: "{time} day(s) ago",
                hour: "{time} hour(s) ago",
                minute: "{time} minute(s) ago",
                second: "{time} second(s) ago"
            },
            storeInformation: {
                title: "Store information"
            },
            payments: {
                title: "Payments"
            },
            orderWindow: {
                title: "Order Window",
                unlinkedOrderMessage: "This order is not linked to an order window",
                selectButton: "Select an order window",
                listeTitle: "Select an order window",
                linkAction: "Link",
                unlinkAction: "Unlink",
                linkError: "Please select at least an order window.",
                unlinkError: "This order is not linked to any order window.",
                linkSuccess: "Order linked successfully to the order window {name}",
                unlinkSuccess: "Order removed successfully from the order window",
                linkedTitle: "This order is linked to the following order window",
                titleOrderWindowInformation: "Order window information",
                titleOrderWindowUpcoming: "Upcoming order windows",
                from: "From",
                to: "to",
                description: "Description",
                titleOrderLink: "Orders linked to the order window",
                orderId: "Order id",
                buyer: "Buyer",
                status: "Status",
                lastUpdate: "Last update",
                msgEmptyOrder: "No orders linked to this order window"
            },
            deliveryAddress: {
                title: "Delivery address",
                addDeliveryAddress: "Add delivery address",
                btnAdd: "Add",
                btnModify: "Modify",
                TitleAdd: "Enter your delivery address",
                TitleModify: "Change your delivery address"
            },
            buyerInformation: {
                title: "Buyer information"
            },
            people: {
                title: "People associated this order"
            },
            labelPurchaseOrder: "Please enter your purchase order ref for this order",
            purshaseOrderTitle: "Purchase Order",
            sendPurchaseOrder: "Send",
            addPurchaseOrderSuccess: "Purchase order added successfully",
            shipOrder: {
                title: "Ship order",
                textHeader: "If you have shipping reference, please specify it here :"
            }
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./static/mocks/i18n.js
// module id = 216
// module chunks = 0